import { FormControl } from '@angular/forms';
import {
  AccessEnum,
  BarcodeTypeEnum,
  BankStorageKindEnum,
  FiscalTypeEnum,
  FuelTypeEnum,
  MoneyAdjustmentDirectionEnum,
  MoneyDayCollectionStatusEnum,
  MoneyDayStatusEnum,
  MoneyTypeEnum,
  BuyDocStatus
} from './enums';

export enum OrderType {
  PROM = 'PROM',
  ROZETKA = 'ROZETKA',
  MANAGER = 'MANAGER',
  AUTOF = 'AUTOF'
}

export enum DeliveryType {
  NP = 'Нова пошта',
  PICKUP = 'Самовивіз'
}

export enum OrderDeliveryMethod {
  PICKUP = 'PICKUP',
  NOVA_POSHTA = 'NOVA_POSHTA'
}

export enum NovaPoshtaDeliveryKind {
  WAREHOUSE = 'WAREHOUSE',
  POSTOMAT = 'POSTOMAT'
}

export interface NovaPoshtaCity {
  ref: string;
  name: string;
  present: string;
  settlementRef?: string | null;
  area?: string | null;
  region?: string | null;
  warehouses?: number | null;
}

export interface NovaPoshtaWarehouse {
  warehouseRef: string;
  number?: string | null;
  description: string;
  shortAddress?: string | null;
  kind: NovaPoshtaDeliveryKind;
  cityRef?: string | null;
  warehouseTypeRef?: string | null;
}

export interface OrderNovaPoshtaDelivery {
  kind: NovaPoshtaDeliveryKind;
  recipientFirstName?: string | null;
  recipientLastName?: string | null;
  recipientPhone?: string | null;
  cityRef: string;
  cityName: string;
  settlementRef?: string | null;
  areaName?: string | null;
  regionName?: string | null;
  warehouseRef: string;
  warehouseDescription: string;
  warehouseNumber?: string | null;
  warehouseTypeRef?: string | null;
  warehouseShortAddress?: string | null;
}

export interface OrderDelivery {
  method: OrderDeliveryMethod;
  novaPoshta?: OrderNovaPoshtaDelivery;
}

export interface ArticleCreateDto {
  article: string;
  product_id: number;
}

export interface ArticleUpdateDto {
  id: number;
  article?: string;
  product_id?: number;
}

export interface ArticleSearchDto {
  id?: number;
  article?: string;
  product_id?: number;
  limit?: number;
  offset?: number;
  order?: string;
}

// bank.service.ts
export interface SearchBankDto {
  readonly id?: number;
  readonly description?: string;
  readonly storageKind?: BankStorageKindEnum;
  readonly warehouse_id?: number;
  readonly owner_user_id?: number;
  readonly isOperational?: boolean;
  limit: number;
  offset: number;
  sort_action: string;
  sort_direction: string;
}

// car-model.service.ts
export interface CarModel {
  id: number;
  description: string;
  manufacture_date_from: Date;
  manufacture_date_to?: Date;
  body: string;
  carModelTypes?: CarModelType[];
  manufacturer?: Manufacturer;
}

export interface SearchCarModelDto {
  id?: number;
  date_from?: Date;
  date_to?: Date;
  bodyType?: string;
  manufacturer_id?: number;
  limit?: number;
  offset?: number;
  order?: string;
}

export interface CreateCarModelDto {
  description: string;
  date_from: Date;
  date_to?: Date;
  body: string;
  manufacturer_id: number;
}
export interface UpdateCarModelDto {
  id: number;
  description?: string;
  manufacture_date_from?: Date;
  manufacture_date_to?: Date;
  body?: string;
  manufacturer_id?: number;
}

// car-model-type.service.ts
export interface CreateCarModelTypeDto {
  readonly description: string;
  readonly manufacture_date_from: Date;
  readonly manufacture_date_to?: Date;
  readonly engineIds: number[];
  readonly carModelId: number;
}

export interface AddInfoRowDto {
  readonly description: string;
  readonly value: string;
  readonly car_id: number;
}

export interface UpdateInfoRowDto {
  readonly id: number;
  readonly description: string;
  readonly value: string;
}

export interface UpdateCarModelTypeDto {
  readonly id: number;
  readonly description?: string;
  readonly manufacture_date_from?: Date;
  readonly manufacture_date_to?: Date;
  readonly engineIds?: number[];
  readonly carModelId?: number;
}

export interface AddProductsDto {
  readonly product_ids: number[];
  readonly id: number;
}

export interface SearchCarModelTypeDto {
  readonly id?: number;
  readonly description?: string;
  readonly date_from?: Date;
  readonly date_to?: Date;
  readonly engineIds?: number[];
  readonly carModelId?: number;
  readonly limit?: number;
  readonly offset?: number;
  readonly order?: string;
}

export interface CarModelType {
  id: number;
  description: string;
  manufacture_date_from: Date;
  manufacture_date_to?: Date;
  engines: Engine[];
  carModel?: CarModel;
  products?: Product[];
  info_row?: InfoRow[];
}

export interface InfoRow {
  id: number;
  description: string;
  value: string;
  car?: CarModelType;
}

export interface AddProductToCarDto {
  readonly car_id: number;
  readonly product_id: number;
}

export interface RemoveProductFromCarDto {
  readonly car_id: number;
  readonly product_id: number;
}
export interface ProductInCarDto {
  readonly product_ids: number[];
  readonly car_id: number;
}

export interface Image {
  // @todo change name
  id: number;
  name: string;
  url: string;
  isPrimary?: boolean;
}

export interface ProductWithControls {
  product: Product;
  price?: number;
  VAT?: number;
  retail?: number;
  quan?: number;
  cell?: string;
  id?: number;
}

export interface ProductWithControlsC {
  product: FormControl<Product | null>;
  price?: FormControl<number>;
  VAT?: FormControl<number>;
  retail?: FormControl<number>;
  quan?: FormControl<number>;
  cell?: FormControl<string>;
  id?: FormControl<number>;
}

export interface Product {
  article: string;
  barcode?: string;
  articleTrim: string;
  brand: Brand;
  public: boolean;
  prom?: boolean;
  avtopro?: boolean;
  updateRetail?: boolean;
  description: string;
  description_ua: string;
  description_long?: string;
  description_long_ua?: string;
  id: number;
  searchKeys?: SearchKey[];
  price: number;
  retail: number;
  fixedMarkupPercent?: number | null;
  pricingProviderId?: number | null;
  pricingProvider?: Provider | null;
  articles?: Article[];
  qty: string;
  stable: number;
  analogue_folder?: AnalogueFolder | undefined | null;
  analogies?: Product[];
  folder?: Folder | undefined | null;
  folders?: Folder[];
  stock: ProductInWarehouse[];
  cellBalances?: ProductCellBalance[];
  stockSummary?: Record<string, ProductStockSummary>;
  properties?: { id: number; value: string; property: Property }[];
  images?: Image[];
  barcodes?: Array<{
    id: number;
    barcode: string;
    shared_products?: Array<{ id: number; description: string; article: string; brand: string }>;
  }>;
  lastProviders?: {
    provider: Provider;
    date: Date;
    import_doc_id: number;
    price: number;
  }[];
  providerStock?: ProductInProviderWarehouse[];
}

export type ProductRelationType = 'ANALOG' | 'OE';
export type ProductRelationSourceKind = 'MANUAL' | 'SUPPLIER';

export interface ProductAnalogueSupplierBadge {
  contractId: number;
  providerCode: string;
  providerName: string;
  contractNumber?: string | null;
}

export interface ProductAnalogueSupplierSource {
  contractId: number;
  providerCode: string;
  providerName: string;
  orgId?: number | null;
  orgName?: string | null;
  contractNumber?: string | null;
  isEnabled: boolean;
  autoRunEnabled: boolean;
  supportsSync: boolean;
  supportsLoadByArticle: boolean;
}

export interface SupplierAnalogueImportConfig {
  id: number;
  contractId: number;
  providerCode: string;
  isEnabled: boolean;
  autoRunEnabled: boolean;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}

export interface UpsertSupplierAnalogueImportConfigDto {
  contract_id: number;
  provider_code: string;
  is_enabled: boolean;
  auto_run_enabled: boolean;
}

export interface ProductAnalogueSyncStatus {
  contractId: number;
  providerCode: string;
  providerName: string;
  lastRunId?: number | null;
  lastStatus?: string | null;
  lastStartedAt?: Date | string | null;
  lastFinishedAt?: Date | string | null;
  lastMessage?: string | null;
}

export interface ProductAnalogueV2Item {
  relationType: ProductRelationType;
  sourceKind: ProductRelationSourceKind;
  product: Product;
  supplierSources: ProductAnalogueSupplierBadge[];
}

export interface ProductAnalogueSupplierOeNumber {
  contractId: number;
  providerCode: string;
  providerName: string;
  contractNumber?: string | null;
  brand: string;
  article: string;
  name?: string | null;
}

export interface ProductAnaloguesV2Response {
  manual: ProductAnalogueV2Item[];
  supplier: ProductAnalogueV2Item[];
  oe: ProductAnalogueV2Item[];
  supplierOeNumbers: ProductAnalogueSupplierOeNumber[];
  warehouseLegend: NewCatalogWarehouseLegend[];
  availableSuppliers: ProductAnalogueSupplierSource[];
  selectedFirmContext: {
    orgId: number;
    orgName: string;
  };
  syncStatus: ProductAnalogueSyncStatus[];
}

export interface ProductAnalogueManualUpsertDto {
  source_product_id: number;
  target_product_id: number;
}

export interface ProductAnalogueSupplierLoadDto {
  source_product_id: number;
  contract_id?: number;
  selected_sub_group_code?: string;
}

export interface ProductAnalogueSupplierExcludeDto {
  source_product_id: number;
  target_product_id: number;
  contract_id: number;
  provider_code: string;
  relation_type: ProductRelationType;
}

export interface ProductAnalogueSupplierGroupSelectionRequiredError {
  code: 'SUPPLIER_GROUP_SELECTION_REQUIRED';
  message: string;
  providerCode: string;
  contractId: number;
  lookupArticle: string;
  availableSubGroupCodes: string[];
}

export interface ProductImportFromExistRequest {
  selected_exist_product_id?: number;
}

export interface ProductImportFromExistCandidate {
  exist_product_id: number;
  article: string;
  brand: string;
  description: string;
  image?: string;
  exist_url: string;
}

export interface ProductImportFromExistReport {
  updated_ua_fields: string[];
  added_images: number;
  created_analog_products: number;
  linked_analog_products: number;
  created_oe_products: number;
  linked_oe_products: number;
  updated_exist_link: boolean;
  skipped_duplicates: number;
}

export interface ProductImportFromExistNotFoundResult {
  status: 'not_found';
}

export interface ProductImportFromExistNeedsSelectionResult {
  status: 'needs_selection';
  candidates: ProductImportFromExistCandidate[];
}

export interface ProductImportFromExistImportedResult {
  status: 'imported';
  product: Product;
  report: ProductImportFromExistReport;
}

export type ProductImportFromExistResult =
  | ProductImportFromExistNotFoundResult
  | ProductImportFromExistNeedsSelectionResult
  | ProductImportFromExistImportedResult;

export type UnifiedProductMovementSource = 'legacy' | 'stock';
export type UnifiedProductMovementDirection = 'IN' | 'OUT' | 'MOVE' | 'INFO';

export type UnifiedProductMovementEventType =
  | 'CUSTOMER_ORDER'
  | 'SUPPLIER_ORDER'
  | 'EXPECTED_RECEIPT'
  | 'PHYSICAL_RECEIPT'
  | 'GOODS_RECEIPT'
  | 'RESERVATION_CREATED'
  | 'RESERVATION_PICKED'
  | 'RESERVATION_CONSUMED'
  | 'RESERVATION_RELEASED'
  | 'PICKING_STARTED'
  | 'PICKING_COMPLETED'
  | 'SHIPMENT'
  | 'CUSTOMER_RETURN'
  | 'SUPPLIER_RETURN'
  | 'TRANSFER'
  | 'WRITE_OFF'
  | 'SURPLUS'
  | 'REGRADING'
  | 'INVENTORY'
  | 'ADJUSTMENT';

export interface UnifiedProductMovementUser {
  id: number;
  name: string | null;
}

export interface UnifiedProductMovementWarehouse {
  id: number;
  name: string | null;
}

export interface UnifiedProductMovementOrganization {
  id: number;
  name: string | null;
}

export interface UnifiedProductMovementStockBalance {
  warehouseId: number;
  warehouseName: string | null;
  quantity: number | null;
  source: 'recorded' | 'unavailable';
}

export interface UnifiedProductMovementItem {
  date: Date | string;
  eventType: UnifiedProductMovementEventType;
  kind: string;
  type: string;
  direction: UnifiedProductMovementDirection;
  quantity: number;
  price: number | null;
  documentType: string;
  documentId: number;
  counterparty?: string | null;
  invoiceNumber?: string | null;
  organization?: UnifiedProductMovementOrganization | null;
  contract?: { id: number; number: string | null } | null;
  warehouseFrom: UnifiedProductMovementWarehouse | null;
  warehouseTo: UnifiedProductMovementWarehouse | null;
  stockBalances?: UnifiedProductMovementStockBalance[];
  user: UnifiedProductMovementUser | null;
  source: UnifiedProductMovementSource;
  status?: string | null;
  note?: string | null;
}

export interface UnifiedProductMovementResponse {
  data: UnifiedProductMovementItem[];
  length: number;
}

export interface BrandCreateDto {
  readonly description: string;
  readonly oe: boolean | undefined;
  readonly short_description?: string | null;
  readonly country?: string | null;
  readonly rating?: number | null;
  readonly logo?: string | null;
}

export interface BrandUpdateDto {
  readonly id: number;
  readonly description?: string | undefined;
  readonly oe?: boolean | undefined;
  readonly short_description?: string | null;
  readonly country?: string | null;
  readonly rating?: number | null;
  readonly logo?: string | null;
}

export interface BrandRatingQueueItem {
  id: number;
  description: string;
  oe: boolean;
  /** Строк реализации за последние 365 дней — насколько бренд для нас ходовой. */
  sales_365: number;
  /** Сколько раз бренд попадал в предложения подбора. */
  match_hits: number;
  products: number;
}

export interface AddAnotherDescription {
  readonly id: number;
  readonly description: string;
}

export interface MergeBrandsDto {
  readonly main_id: number;
  readonly another_id?: number;
  readonly another_ids?: number[];
}

export interface SearchBrandDto {
  readonly id?: number;
  readonly description?: string;
  readonly short_description?: string;
  readonly strict_description?: string;
  readonly order?: string;
  readonly limit?: number;
}

export interface Brand {
  id: number;
  description: string;
  short_description: string | null;
  country?: string | null;
  rating?: number | null;
  logo?: string | null;
  oe: boolean;
  another_descriptions?: AnotherBrandDescription[];
}

export type BrandBindingNameType = 'canonical' | 'short' | 'alias';

export interface BrandBindingNameItem {
  value: string;
  type: BrandBindingNameType;
}

export interface BrandBindingConflict {
  id: number;
  description: string;
  shortDescription: string | null;
  productCount: number;
  matchedNames: string[];
}

export interface BrandBindings {
  currentNames: BrandBindingNameItem[];
  conflicts: BrandBindingConflict[];
}

export interface AnotherBrandDescription {
  id: number;
  description: string;
  brand?: Brand;
}

export interface Manufacturer {
  id: number;
  description: string;
  ad_id?: number;
  engines?: Engine[];
  carModels?: CarModel[];
}

export interface ManufacturerSearchDto {
  id?: number;
  description?: string;
  date_from?: Date;
  date_to?: Date;
  ad_id?: number;
  limit?: number;
  offset?: number;
}

export interface CreateManufacturerDto {
  readonly description: string;
}

export interface UpdateManufacturerDto {
  id: number;
  description?: string;
  engine_ids?: number[];
  carModel_ids?: number[];
}

export interface Engine {
  id: number;
  description: string;
  fuelType: FuelTypeEnum;
  horsePower: string;
  kW: string;
  manufacturer?: Manufacturer;
  carModelTypes?: CarModelType;
}

export interface CreateEngineDto {
  readonly description: string;
  readonly fuelType: FuelTypeEnum;
  readonly horsePower?: number;
  readonly kW?: number;
  readonly capacity: number;
  readonly manufacturer_id: number;
}

export interface UpdateEngineDto {
  readonly id: number;
  readonly description?: string;
  readonly fuelType?: FuelTypeEnum;
  readonly horsePower?: number;
  readonly kW?: number;
  readonly capacity: number;
  readonly manufacturer_id?: number;
}

export interface SearchEngineDto {
  readonly id?: number;
  readonly description?: string;
  readonly fuelType?: FuelTypeEnum;
  readonly horsePower_from?: number;
  readonly horsePower_to?: number;
  readonly kW_from?: number;
  readonly kW_to?: number;
  readonly manufacturer_id?: number;
  readonly car_model_type_id?: number;
  readonly limit?: number;
  readonly offset?: number;
  readonly order?: string;
}

export interface AnalogueFolder {
  id: number;
  products: Product[];
}

export interface Folder {
  id: number;
  description: string;
  image: string;
  children: Folder[];
  products?: Product[];
  sort_order?: number;
  public?: boolean;
  parentFolderId?: number | null;
}

export interface ProductInWarehouse {
  id: number;
  quan: number;
  customerReservedQuantity?: number;
  transferReservedQuantity?: number;
  supplierReturnReservedQuantity?: number;
  reservedQuantity?: number;
  freeQuantity?: number;
  minimumStock?: number;
  cell: string;
  product?: Product;
  warehouse: Warehouse;
}

export type WarehouseCellType = 'REAL' | 'BUFFER' | 'UNASSIGNED_OUT' | 'IN_HANDS';

export interface WarehouseCell {
  id: number;
  warehouseId: number;
  code: string;
  type: WarehouseCellType;
  isActive: boolean;
  sortOrder: number;
}

export interface ProductCellBalance {
  productId: number;
  warehouseId: number;
  cellId: number;
  code: string;
  type: WarehouseCellType;
  qty: number;
  isVirtual: boolean;
}

export interface ProductStockSummary {
  aggregateQty: number;
  placedQty: number;
  bufferQty: number;
  unassignedOutQty: number;
  recommendedCells: string[];
}

export interface VirtualCellOffsetState {
  aggregateQty: number;
  placedQty: number;
  bufferQty: number;
  unassignedOutQty: number;
}

export interface VirtualCellOffsetPreview {
  warehouseId: number;
  productId: number;
  canResolve: boolean;
  resolveQty: number;
  reason: string | null;
  before: VirtualCellOffsetState;
  after: VirtualCellOffsetState;
}

export interface ResolveVirtualCellOffsetResult extends VirtualCellOffsetPreview {
  balances: ProductCellBalance[];
}

export interface Warehouse {
  id: number;
  description: string;
  city: City;
  inventoryValue?: number;
}

export interface Provider {
  // @todo исправить нейминг на более понятный
  id: number;
  description: string;
  fullDescription: string;
  balance?: number;
  taxNum?: string;
  orgNum?: string;
  uploadDescription?: string;
  uploadBrand?: string;
  uploadArticle?: string;
  uploadPrice?: string;
  providerWarehouse?: ProviderWarehouse[];
}

export interface City {
  id: number;
  description: string;
}

export interface CreateCityDto {
  description: string;
}

export interface UpdateCityDto {
  id: number;
  description?: string;
}

export interface SearchCityDto {
  id?: number;
  description?: string;
  limit?: number;
  offset?: number;
  order?: string;
}
// Настройки доставки со склада поставщика. Дни недели — ISO: 1 = Пн ... 7 = Вс.
export interface OwnDeliveryRule {
  arrivalDays?: number[]; // Допустимые дни прибытия; пусто = календарные дни.
  days: number[];
  cutoff: string; // 'HH:mm' — заказ до этого времени
  arrivalDayOffset: number; // 0 = в тот же день, 1 = на следующий
  arrivalFrom?: string;
  arrivalTo?: string;
}

export interface CarrierDeliveryRule {
  days: number[];
  cutoff: string;
  shipDayOffset?: number; // 0 = отправка в день заказа
  transitDays?: number;
}

export interface RunsDeliveryRule {
  cutoff?: string;
  arrivalFrom?: string;
  arrivalTo?: string;
  arrivalDayOffset?: number;
  days: number[];
  departures: string[]; // 'HH:mm'
  transitMinutes?: number;
}

export interface OwnDeliveryMethod {
  type: 'own';
  rules: OwnDeliveryRule[];
}

export interface CarrierDeliveryMethod {
  type: 'carrier';
  carrier?: string;
  rules: CarrierDeliveryRule[];
}

export interface RunsDeliveryMethod {
  type: 'runs';
  rules: RunsDeliveryRule[];
}

export interface PickupDeliveryRule {
  days: number[]; // пусто = любой день
  from?: string;
  to?: string;
}

export interface PickupDeliveryMethod {
  type: 'pickup';
  travelMinutes?: number;
  handlingMinutes?: number;
  distanceKm?: number;
  address?: string;
  rules?: PickupDeliveryRule[];
  // Легаси-формат (одно расписание плоскими полями) — старые сохранённые данные.
  days?: number[];
  from?: string;
  to?: string;
}

export type ProviderWarehouseDeliveryMethod =
  | OwnDeliveryMethod
  | CarrierDeliveryMethod
  | RunsDeliveryMethod
  | PickupDeliveryMethod;

export interface ProviderWarehouseDelivery {
  methods: ProviderWarehouseDeliveryMethod[];
  note?: string;
}

export interface ProviderWarehouseDeliveryRoute {
  receiverWarehouseId: number;
  delivery: ProviderWarehouseDelivery | null;
}

export interface ProviderWarehouseDeliveryResponse extends ProviderWarehouseDeliveryRoute {
  providerWarehouseId: number;
}

export interface ProviderWarehouse {
  id: number;
  description: string;
  delivery?: ProviderWarehouseDelivery | null;
  deliveryRoutes?: ProviderWarehouseDeliveryRoute[];
  city: City;
  provider: Provider;
  products?: ProductInProviderWarehouse[];
}

export interface ProductInProviderWarehouse {
  id: string;
  quan: number;
  price?: number;
  retail?: number;
  product?: Product;
  providerWarehouse: ProviderWarehouse;
}

export interface CreateProviderWarehouseDto {
  description: string;
  city_id: number;
  provider_id: number;
  delivery?: ProviderWarehouseDelivery | null;
}
export interface UpdateProviderWarehouseDto {
  id: number;
  description?: string;
  city_id?: number;
  provider_id?: number;
  delivery?: ProviderWarehouseDelivery | null;
}
export interface SearchProviderWarehouseDto {
  id?: number;
  description?: string;
  city_id?: number;
  provider_id?: number;
  limit?: number;
  offset?: number;
  order?: string;
}

export interface Property {
  id: number;
  description: string;
  code?: string;
  kind?: 'enum' | 'number' | 'text';
  unit?: string | null;
  is_filterable?: boolean;
  sort_order?: number;
}
export interface SearchPropertyDto {
  readonly folder_id?: number;
}

export interface GetPropertyValues {
  property_id: number;
  folder_id?: number;
}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

export interface Cart {
  id: number;
  products?: ProductInCart[];
  user?: User;
}
export interface ProductInCart {
  id: number;
  quan: number;
  price: number;
  sum?: number;
  product: Product;
}

export interface OrderListDefaults {
  version: 1;
  manager: 'me' | 'all' | { id: number; name: string };
  warehouse: { id: number; description: string } | null;
  supply_status: OrderSupplyStatus[];
  procurement_status: OrderProcurementStatus[];
  fulfillment_status: OrderFulfillmentStatus[];
  payment_status: OrderPaymentStatus[];
  shipment_status: OrderShipmentStatus[];
}

export interface User {
  id: number;
  name: string;
  phone: string;
  isActive?: boolean;
  fiscal?: Fiscal | null;
  roles: Role[];
  defaultTherminal: string;
  defaultThermalPrinter: string;
  defaultLabelPrinter: string;
  defaultLabelProfile?: LabelProfileRef | null;
  defaultWarehouse: Warehouse;
  defaultOrg: Organization;
  lightmode: boolean;
  catalogueOpenFilter: boolean;
  catalogueOpenFolder: boolean;
  partsSelectionAiEnabled?: boolean;
  orderListDefaults?: OrderListDefaults | null;
  banks: Bank[];
  cart?: Cart;
}

export interface UserRef {
  id: number;
  name: string;
}

export interface UserSearchDto {
  readonly name?: string;
  readonly phone?: string;
  readonly roleId?: number | null;
  readonly isActive?: boolean | null;
  readonly limit?: number;
  readonly offset?: number;
  readonly order?: 'id' | 'name' | 'phone';
  readonly direction?: 'ASC' | 'DESC';
}

export interface AdminCreateUserDto {
  readonly name: string;
  readonly phone: string;
  readonly password: string;
  readonly roleId: number[];
  readonly bankId?: number[];
  readonly defaultWarehouseId: number;
  readonly defaultOrgId: number;
  readonly fiscal_id?: number | null;
  readonly thermalPrinter?: string | null;
  readonly defaultLabelProfileId?: number | null;
  readonly defaultLabelProfileCode?: string | null;
  readonly therminal?: string | null;
  readonly catalogueOpenFilter?: boolean;
  readonly catalogueOpenFolder?: boolean;
  readonly isActive?: boolean;
}

export interface AdminUpdateUserDto {
  readonly id: number;
  readonly name: string;
  readonly phone: string;
  readonly roleId: number[];
  readonly bankId?: number[];
  readonly defaultWarehouseId: number;
  readonly defaultOrgId: number;
  readonly fiscal_id?: number | null;
  readonly thermalPrinter?: string | null;
  readonly defaultLabelProfileId?: number | null;
  readonly defaultLabelProfileCode?: string | null;
  readonly therminal?: string | null;
  readonly catalogueOpenFilter?: boolean;
  readonly catalogueOpenFolder?: boolean;
  readonly isActive?: boolean;
}

export interface AdminSetPasswordDto {
  readonly id: number;
  readonly password: string;
}

export interface UpdateUserStatusDto {
  readonly id: number;
  readonly isActive: boolean;
}

export type RingostatDestinationType = 'sip' | 'phone' | 'schema';
export type RingostatAvailabilityStatus = 'online' | 'dnd_temporary' | 'dnd';

export interface RingostatUserSettings {
  id: number | null;
  userId: number;
  userName: string | null;
  enabled: boolean;
  destinationType: RingostatDestinationType;
  destination: string | null;
  sipLogin: string | null;
  mobileSipLogin: string | null;
  staffId: string | null;
  fallbackPhone: string | null;
  directPhones: string[];
  availabilityStatus: RingostatAvailabilityStatus;
  effectiveAvailabilityStatus: RingostatAvailabilityStatus;
  dndUntil: string | Date | null;
  availableForCalls: boolean;
  effectiveDestination: string | null;
  responseField: string;
  createdAt: string | Date | null;
  updatedAt: string | Date | null;
}

export interface UpsertRingostatUserSettingsDto {
  enabled?: boolean;
  destinationType?: RingostatDestinationType;
  destination?: string | null;
  sipLogin?: string | null;
  mobileSipLogin?: string | null;
  staffId?: string | null;
  fallbackPhone?: string | null;
  directPhones?: string[] | string | null;
  availabilityStatus?: RingostatAvailabilityStatus;
  dndUntil?: string | Date | null;
  dndMinutes?: number | string | null;
}

export interface RingostatIncomingCallNotification {
  eventType: string;
  callId: string | null;
  caller: string | null;
  normalizedCaller: string | null;
  clientId: number | null;
  clientName: string | null;
  clientPhone: string | null;
  managerUserId: number | null;
  managerUserName: string | null;
  ownerManagerUserId?: number | null;
  ownerManagerUserName?: string | null;
  ownerReason?: string | null;
  visibleUserIds?: number[];
  receivedAt: string;
}

export interface RingostatClickToCallRequest {
  phone: string;
  clientId?: number | null;
  clientPhoneId?: number | null;
}

export interface RingostatClickToCallResponse {
  success: boolean;
  caller: string;
  callee: string;
  calleeType: 'default' | 'scheme';
  managerUserId: number;
  managerUserName: string | null;
  ringostatResponse: unknown;
}

export type RingostatCallJournalDirection = 'from_client' | 'to_client' | 'unknown';

export interface RingostatCallJournalItem {
  id: string;
  callId: string | null;
  callDate: string | null;
  callDateLabel: string;
  caller: string | null;
  destination: string | null;
  normalizedCaller: string | null;
  normalizedDestination: string | null;
  clientId: number | null;
  clientName: string | null;
  clientPhone: string | null;
  managerNumber: string | null;
  managerUserId: number | null;
  managerUserName: string | null;
  managerLabel: string | null;
  direction: RingostatCallJournalDirection;
  directionLabel: string;
  status: string | null;
  statusLabel: string;
  durationSec: number;
  durationLabel: string;
  recordingUrl: string | null;
  hasRecording: boolean;
  missed: boolean;
  isVoicemail: boolean;
  unreturnedMissed: boolean;
}

export interface RingostatCallJournalResponse {
  from: string;
  to: string;
  missedOnly: boolean;
  total: number;
  missedTotal: number;
  unreturnedMissedTotal: number;
  voicemailTotal: number;
  items: RingostatCallJournalItem[];
}

export interface RingostatAttentionSummary {
  unreturnedMissedTotal: number;
  voicemailTotal: number;
  total: number;
  updatedAt: string;
}

export type B2cCallbackRequestStatus = 'NEW' | 'DONE';
export type B2cCallbackRequestStatusFilter = B2cCallbackRequestStatus | 'ALL';

export interface B2cCallbackRequest {
  outcome?: string | null;
  outcome_note?: string | null;
  last_attempt_at?: string | Date | null;
  id: number;
  status: B2cCallbackRequestStatus;
  date_created: string | Date;
  date_closed: string | Date | null;
  name: string | null;
  phone: string;
  comment: string | null;
  page_url: string | null;
  client_id: number | null;
  client_name: string | null;
  client_phone: string | null;
  completed_by_user_id: number | null;
  completed_by_user_name: string | null;
}

export interface B2cCallbackRequestListResponse {
  data: B2cCallbackRequest[];
  total: number;
  limit: number;
  offset: number;
}

export interface ConnectedWorkstationAgent {
  deviceId: string;
  agentName: string;
  machineName: string;
  userName: string;
  connectedAt: string;
  agentVersion?: string | null;
  updateChannel?: string | null;
  lastUpdateStatus?: string | null;
}

export type PrinterTargetRole = 'receipt' | 'label';

export type PrintTargetStrategy = 'explicit_agent' | 'warehouse_online' | 'legacy_user_default';
export type LabelProfileMode = 'user_default' | 'printer_target';

export interface LabelProfileLayoutJson {
  schemaVersion?: number;
  units?: 'dots';
  productLabel: {
    margins: {
      left: number;
      right: number;
      top: number;
    };
    article: {
      enabled?: boolean;
      x?: number | null;
      y?: number;
      align?: 'left' | 'center' | 'right';
      font: string;
      xMultiplier: number;
      yMultiplier: number;
      maxLength: number;
      trimLength: number;
      height: number;
      gapAfter: number;
    };
    brand: {
      enabled?: boolean;
      x?: number | null;
      y?: number;
      align?: 'left' | 'center' | 'right';
      font: string;
      xMultiplier?: number;
      yMultiplier?: number;
      maxLength: number;
      trimLength: number;
      height: number;
      bitmapHeight: number;
      bitmapFontSize: number;
      bold: boolean;
      gapAfter: number;
    };
    productName: {
      enabled?: boolean;
      x?: number | null;
      y?: number;
      align?: 'left' | 'center' | 'right';
      forceBitmap: boolean;
      width: number;
      height: number;
      fontSize: number;
      bold: boolean;
      maxLength: number;
      lineLength: number;
      maxLines: number;
      lineStep: number;
      font: string;
    };
    barcode: {
      enabled?: boolean;
      x?: number | null;
      y?: number;
      align?: 'left' | 'center' | 'right';
      barcodeType?: 'auto' | '128' | 'CODE128' | 'EAN13' | 'EAN8';
      height?: number;
      narrow?: number;
      wide?: number;
      readable?: number;
      maxNarrow: number;
      gapAfterText: number;
      bottomReserve: number;
      bottomPadding: number;
      minHeight: number;
      maxHeight: number;
    };
  };
  cellLabel: {
    margins: {
      left: number;
      right: number;
      top: number;
    };
    cellName: {
      enabled?: boolean;
      x?: number | null;
      y?: number;
      align?: 'left' | 'center' | 'right';
      font: string;
      xMultiplier: number;
      yMultiplier: number;
      maxLength: number;
    };
    barcode: {
      enabled?: boolean;
      x?: number | null;
      y?: number;
      align?: 'left' | 'center' | 'right';
      barcodeType?: '128' | 'CODE128';
      height: number;
      narrow: number;
      wide: number;
      readable: number;
      maxNarrow: number;
      width: number;
    };
  };
}

export interface TsplElementRef {
  type: string;
  x: number;
  y: number;
  text?: string;
  content?: string;
  font?: string;
  xMultiplier?: number;
  yMultiplier?: number;
  fontSize?: number;
  bold?: boolean;
  barcodeType?: string;
  height?: number;
  readable?: number;
  narrow?: number;
  wide?: number;
  width?: number;
}

export interface TsplLabelRef {
  widthMm?: number;
  heightMm?: number;
  gapMm?: number;
  direction?: number;
  copies?: number;
  speed?: number;
  density?: number;
  characterEncoding?: string;
  codePage?: string;
  elements: TsplElementRef[];
}

export interface LabelProfileRef {
  id: number | string;
  code?: string | null;
  name?: string | null;
  widthMm?: number;
  heightMm?: number;
  gapMm?: number;
  direction?: number;
  speed?: number;
  density?: number;
  characterEncoding?: string | null;
  codePage?: string | null;
  isActive?: boolean;
  isDefault?: boolean;
  layoutJson: LabelProfileLayoutJson;
  profileId?: number | string | null;
  profileCode?: string | null;
  profileName?: string | null;
  agentName?: string | null;
}

export interface PrintTargetSelector {
  agentDeviceId?: string | null;
  agentName?: string | null;
  warehouseId?: number | null;
  strategy?: PrintTargetStrategy;
}

export interface PrinterTarget {
  id?: number | string;
  printerId?: number | null;
  deviceId?: string | null;
  label?: string | null;
  code?: string | null;
  role?: PrinterTargetRole;
  status?: 'online' | 'offline';
  agentName?: string | null;
  agentVersion?: string | null;
  updateChannel?: string | null;
  lastUpdateStatus?: string | null;
  displayName?: string | null;
  machineName?: string | null;
  userName?: string | null;
  warehouseId?: number | null;
  profileId?: number | string | null;
  profileCode?: string | null;
  profileName?: string | null;
  profile?: LabelProfileRef | null;
  isDefaultForWarehouse?: boolean;
  isConnected?: boolean;
  strategy?: PrintTargetStrategy;
}

export interface WorkstationPrinterRecord {
  id: number;
  deviceId: string;
  warehouseId: number;
  warehouse?: Warehouse;
  role: PrinterTargetRole;
  displayName: string;
  isEnabled: boolean;
  isDefaultForWarehouse: boolean;
  priority: number;
  labelProfileId?: number | null;
  labelProfile?: LabelProfileRef | null;
}

export interface CreateLabelProfileDto {
  code: string;
  name: string;
  widthMm: number;
  heightMm: number;
  gapMm: number;
  direction: number;
  speed: number;
  density: number;
  characterEncoding: string;
  codePage?: string | null;
  isActive?: boolean;
  isDefault?: boolean;
  layoutJson: LabelProfileLayoutJson;
}

export interface UpdateLabelProfileDto extends Partial<CreateLabelProfileDto> {}

export interface CreateWorkstationPrinterDto {
  deviceId: string;
  warehouseId: number;
  role: PrinterTargetRole;
  displayName: string;
  isEnabled?: boolean;
  isDefaultForWarehouse?: boolean;
  priority?: number;
  labelProfileId?: number | null;
}

export interface UpdateWorkstationPrinterDto extends Partial<CreateWorkstationPrinterDto> {}

export interface FiscalSessionChange {
  fiscalId: number;
  isSessionOpen: boolean;
}

export interface Fiscal {
  id: number;
  name: string;
  token?: string;
  address: string;
  isSessionOpen: boolean;
  sum: number;
  type: FiscalTypeEnum;
  sellerDisplayName?: string | null;
  unitDisplayName?: string | null;
  displayTaxIdLabel?: string | null;
  displayTaxIdValue?: string | null;
  fullAddress?: string | null;
  prroFiscalNumber?: string | null;
  printStaticTaxLine?: boolean;
  staticTaxLabel?: string | null;
  staticTaxLetter?: string | null;
  isTestMode?: boolean;
  printLogoOnFiscalReceipt?: boolean;
}

export interface Bank {
  id: number;
  description: string;
  balance: number;
  balance_as_of?: Date | string | null;
  moneyType: MoneyTypeEnum;
  isCollecting: boolean;
  storageKind?: BankStorageKindEnum;
  warehouse?: Warehouse | null;
  ownerUser?: User | null;
  isOperational?: boolean;
}

export type MoneyDayStatus = `${MoneyDayStatusEnum}`;

export type MoneyDayCollectionStatus = `${MoneyDayCollectionStatusEnum}`;

export type MoneyAdjustmentDirection = `${MoneyAdjustmentDirectionEnum}`;

export interface MoneyDayLine {
  money_type: MoneyTypeEnum;
  expected_amount: number;
  actual_amount: number;
  variance_amount: number;
  expected_payment_amount?: number | null;
  actual_payment_amount?: number | null;
  payment_variance_amount?: number | null;
  expected_payment_count?: number | null;
  actual_payment_count?: number | null;
  payment_variance_count?: number | null;
  expected_refund_amount?: number | null;
  actual_refund_amount?: number | null;
  refund_variance_amount?: number | null;
  expected_refund_count?: number | null;
  actual_refund_count?: number | null;
  refund_variance_count?: number | null;
  comment?: string | null;
}

export interface MoneyDayTotals {
  expected_amount: number;
  actual_amount: number;
  variance_amount: number;
}

export interface MoneyDayCashSummary {
  opening_amount: number;
  customer_payments: number;
  customer_refunds: number;
  correction_reversals: number;
  correction_replacements: number;
  adjustments: number;
  expense_amount?: number;
  transfers: number;
  other_movements: number;
  movement_amount: number;
  expected_amount: number;
  actual_amount: number;
  variance_amount: number;
  ledger_balance: number;
  current_ledger_balance: number;
  boundary_at?: Date | string | null;
}

export interface MoneyDayPaymentTypeSummary {
  money_type: MoneyTypeEnum;
  customer_payments: number;
  customer_payment_count?: number | null;
  customer_payment_count_available?: boolean;
  customer_refunds: number;
  customer_refund_count?: number | null;
  customer_refund_count_available?: boolean;
  correction_reversals: number;
  correction_reversal_count?: number;
  correction_replacements: number;
  correction_replacement_count?: number;
  unclassified_movement_count?: number;
  adjustments: number;
  transfers: number;
  other_movements: number;
  net_amount: number;
  movement_amount: number;
  source_count: number;
  reconciliation_requires_review?: boolean;
  reconciliation_review_reasons?: string[];
  reconciliation_warnings?: string[];
  container_ids?: number[];
  container_count?: number;
}

export type MoneyDayReconciliationStatus =
  | 'NOT_SUBMITTED'
  | 'PENDING_ADMIN'
  | 'CHANGES_REQUESTED'
  | 'VERIFIED'
  | 'LEGACY'
  | 'STALE';

export interface MoneyDayTerminalReconciliationLine {
  id?: number;
  payment_terminal_id?: number | null;
  terminal_profile_id?: number | null;
  terminal_label?: string | null;
  provider?: string | null;
  merchant_id?: string | null;
  terminal_id?: string | null;
  provider_batch_id?: string | null;
  expected_sale_amount?: number | null;
  expected_sale_count?: number | null;
  expected_refund_amount?: number | null;
  expected_refund_count?: number | null;
  expected_void_amount?: number | null;
  expected_void_count?: number | null;
  reported_sale_amount?: number | null;
  reported_sale_count?: number | null;
  reported_refund_amount?: number | null;
  reported_refund_count?: number | null;
  reported_void_amount?: number | null;
  reported_void_count?: number | null;
  confirmed_no_refunds?: boolean;
  comment?: string | null;
  legacy_unidentified?: boolean;
  sale_variance_amount?: number | null;
  sale_variance_count?: number | null;
  refund_variance_amount?: number | null;
  refund_variance_count?: number | null;
  void_variance_amount?: number | null;
  void_variance_count?: number | null;
  pending_operation_count?: number;
  unbooked_operation_count?: number;
  warnings?: string[];
  reconciliation_warnings?: string[];
}

export interface MoneyDayReconciliationSubmission {
  id: number;
  money_day_id: number;
  revision: number;
  status: MoneyDayReconciliationStatus | string;
  request_id?: string | null;
  boundary_at?: Date | string | null;
  closed_ledger_entry_id?: number | null;
  submitted_by_user_id?: number | null;
  submitted_by_user_name?: string | null;
  submitted_at?: Date | string | null;
  reviewed_by_user_id?: number | null;
  reviewed_by_user_name?: string | null;
  reviewed_at?: Date | string | null;
  review_comment?: string | null;
  rejection_reason?: string | null;
  close_comment?: string | null;
  reported_lines?: MoneyDayLine[];
  lines: MoneyDayTerminalReconciliationLine[];
  created_at?: Date | string | null;
}

export interface MoneyCashboxChangedEvent {
  cashbox_id: number;
  money_day_id: number;
  manager_user_id: number;
  warehouse_id: number;
  ledger_entry_id: number | null;
  occurred_at: Date | string;
  change_kind?: 'MOVEMENT' | 'LIFECYCLE';
}

export interface MoneyFlowChangedEvent {
  manager_user_id: number;
  warehouse_id: number;
  money_day_id?: number | null;
  source_doc_type: string;
  source_doc_id: number;
  change_kind: 'PAYMENT' | 'REFUND' | 'CORRECTION' | 'SERVICE' | 'CASHBOX' | 'LIFECYCLE';
  occurred_at: Date | string;
}

export interface CurrentMoneyDaySummary {
  day_id: number | null;
  business_date: Date | string | null;
  status: MoneyDayStatus | null;
  collection_status: MoneyDayCollectionStatus | null;
  warehouse_id?: number | null;
  warehouse_name?: string | null;
  cash_expected: number;
  cash_actual: number;
  cash_variance: number;
  cashbox_id?: number | null;
  cashbox_name?: string | null;
  cashbox_balance?: number;
  opening_cash_amount?: number;
  cash_summary?: MoneyDayCashSummary | null;
  can_close: boolean;
  can_collect: boolean;
}

export interface MoneyCollection {
  id: number;
  money_day_id: number | null;
  manager_user_id: number | null;
  manager_name: string | null;
  warehouse_id: number | null;
  warehouse_name: string | null;
  manager_cashbox_id: number | null;
  manager_cashbox_name?: string | null;
  central_safe_id: number | null;
  central_safe_name?: string | null;
  money_type: MoneyTypeEnum;
  accepted_cash_amount: number;
  float_left_in_cashbox: number;
  collected_to_safe: number;
  collection_variance: number;
  accepted_by_user_id: number | null;
  accepted_by_user_name: string | null;
  accepted_at: Date | string;
  comment?: string | null;
  created_at?: Date | string;
  timeline?: MoneyEvent[];
}

export interface MoneyDay {
  id: number;
  manager_user_id: number | null;
  manager_name: string | null;
  warehouse_id: number | null;
  warehouse_name: string | null;
  business_date: Date | string;
  status: MoneyDayStatus;
  collection_status: MoneyDayCollectionStatus;
  opened_at: Date | string;
  closed_at?: Date | string | null;
  closed_by_user_id?: number | null;
  closed_by_user_name?: string | null;
  close_comment?: string | null;
  lines: MoneyDayLine[];
  totals: MoneyDayTotals;
  current_expected_lines: MoneyDayLine[];
  current_expected_total: number;
  cashbox_id?: number | null;
  cashboxId?: number | null;
  cashbox_name?: string | null;
  cashbox_balance?: number;
  opening_cash_amount?: number;
  openingCashAmount?: number;
  closed_ledger_entry_id?: number | null;
  closedLedgerEntryId?: number | null;
  cash_summary?: MoneyDayCashSummary | null;
  payment_type_summary?: MoneyDayPaymentTypeSummary[];
  reconciliation_status?: MoneyDayReconciliationStatus | string | null;
  latest_reconciliation_id?: number | null;
  terminal_reconciliation_expected?: MoneyDayTerminalReconciliationLine[];
  latest_reconciliation?: MoneyDayReconciliationSubmission | null;
  reconciliation_history?: MoneyDayReconciliationSubmission[];
  cash_shift_movement?: number;
  cash_carry_amount?: number;
  can_collect: boolean;
  collection?: MoneyCollection | null;
  timeline?: MoneyEvent[];
  timeline_total?: number;
  timeline_has_more?: boolean;
  post_collection_corrections?: MoneyEvent[];
}

export type MoneyDayTimelineRow = MoneyEvent;

export interface MoneyAdjustment {
  id: number;
  date: Date | string;
  business_date: Date | string;
  direction: MoneyAdjustmentDirection;
  money_type: MoneyTypeEnum;
  value: number;
  comment?: string | null;
  actor_user_id: number | null;
  actor_user_name: string | null;
  manager_user_id: number | null;
  manager_user_name: string | null;
  warehouse_id: number | null;
  warehouse_name: string | null;
  bank_id: number | null;
  bank_name?: string | null;
  created_at?: Date | string;
  timeline?: MoneyEvent[];
}

export interface MoneyTransfer {
  id: number;
  date: Date | string;
  business_date: Date | string;
  money_type: MoneyTypeEnum;
  value: number;
  comment?: string | null;
  actor_user_id: number | null;
  actor_user_name: string | null;
  manager_user_id: number | null;
  manager_user_name: string | null;
  warehouse_id: number | null;
  warehouse_name: string | null;
  bank_from_id: number | null;
  bank_from_name?: string | null;
  bank_to_id: number | null;
  bank_to_name?: string | null;
  created_at?: Date | string;
  timeline?: MoneyEvent[];
}

export interface MoneyEvent {
  id: number;
  occurred_at: Date | string;
  business_date: Date | string;
  money_day_id?: number | null;
  event_type: string;
  actor_user_id: number | null;
  actor_user_name: string | null;
  manager_user_id: number | null;
  manager_user_name: string | null;
  warehouse_id: number | null;
  warehouse_name: string | null;
  money_type?: MoneyTypeEnum | null;
  amount_signed: number;
  perspective_amount_signed?: number;
  source_doc_type?: string | null;
  source_doc_id?: number | null;
  operation_key?: string | null;
  ledger_entry_id?: number | null;
  operationKey?: string | null;
  ledgerEntryId?: number | null;
  container_from_id?: number | null;
  container_from_name?: string | null;
  container_to_id?: number | null;
  container_to_name?: string | null;
  category?: string | null;
  comment?: string | null;
  payload_json?: Record<string, unknown> | null;
}

export type MoneyContainer = Bank;

export interface ExportDoc {
  id: number;
  date_created: Date;
  date: Date;
  passed: boolean;
  paid: boolean;
  bank: Bank;
  fiscal: boolean;
  fiscalCode: string;
  fiscalQR: string;
  user: User;
  client: Client;
  client_car?: ClientCar;
  warehouse: Warehouse;
  products: ProductInDoc[];
  credit_warning?: ClientDebtWarning | null;
  warnings?: string[];
  generated_docs?: {
    invoice_id?: number;
    payment_id?: number | null;
    shipment_id?: number;
    fiscal_status?: string;
    credit_warning?: ClientDebtWarning | null;
    warnings?: string[];
  };
}

export interface Organization {
  id: number;
  name: string;
  fullName?: string;
  shipmentSignatoryName?: string | null;
  shipmentSignatoryPosition?: string | null;
  edrpou?: string;
  ipn?: string;
  taxationType?: string;
  legalAddress?: string;
  actualAddress?: string;
  phone?: string;
  email?: string;
  isActive?: boolean;
  director?: User;
  accountant?: User;

  // Deprecated legacy fields. Use bankAccounts instead.
  bankAccount?: string;
  bankName?: string;
  mfo?: string;
  bankAccounts?: OrgBankAccount[];
}

export interface OrgBankAccount {
  id: number;
  iban: string;
  bankName?: string;
  accountName?: string;
  isPrimary: boolean;
  isActive: boolean;
  organization?: Organization;
}

export interface Role {
  id: number;
  description: string;
  normalize_description: string;
}

export interface CreateCartDto {
  user_id: number;
}

export interface UpdateCartDto {
  id: number;
  user_id: number;
}

export interface AddProductToCartDto {
  id: number;
  product_id: number;
}

export interface RemoveProductFromCartDto {
  id: number;
  product_id: number;
}

export interface UpdateProductInCartDto {
  id: number;
  price?: number;
  quan?: number;
}

export interface UploadImageDto {
  product_id: number;
  image: string;
}

export interface UploadNewProductsFile {
  description_column: string;
  article_column: string;
  brand_column: string;
  image_column: string;
  folder_column: string;
  file: File;
}

export interface RemoveDouble {
  preview_token?: string;
  operation_id?: string;
  confirmed_identity?: boolean;
  reason?: string;
  main_id: number;
  another_id?: number;
  another_ids?: number[];
  new_price?: boolean;
  save_description?: boolean;
}

export interface RemoveDoubleResult {
  main_id: number;
  merged_ids: number[];
  skipped_ids: number[];
  merged_count: number;
}

export interface ProductCreateDto {
  description: string;
  article: string;
  brand_id?: number;
  brand?: string;
  barcode?: string;
  description_long?: string;
  qty?: string;
  price?: number;
  retail?: number;
  searchKeys?: string;
  imgs?: string[];
  barcodes?: string[];
}

export interface ProductUpdateDto {
  id: number;
  description?: string;
  description_ua?: string;
  description_long?: string;
  description_long_ua?: string;
  searchKeys?: string;
  article?: string;
  brand_id?: number;
  retail?: number;
  public?: boolean;
  fixedMarkupPercent?: number | null;
  pricing_provider_id?: number | null;
  folder_id?: number;
  prom?: boolean;
  avtopro?: boolean;
  updateRetail?: boolean;
  stable?: number;
}

export interface ProductAddBarcodeDto {
  product_id: number;
  barcode: string;
  allow_shared?: boolean;
}

export interface ProductRemoveBarcodeDto {
  product_id: number;
  barcode: string;
}

export interface ProductAddAnalogueDto {
  product_id_1: number;
  product_id_2: number;
}

export interface ToggleSearchKey {
  productId: number;
  key: string;
}

export interface SearchKey {
  key: string;
  productId?: number;
}

export interface UpdateRetailPriceDto {
  product_id: number;
  retail: number;
}

export interface ProductSearchDto {
  id?: number | null;
  search_keys?: string | null;
  barcode?: string | null;
  article?: string | null;
  article_like?: boolean | null;
  brand_id?: number | null;
  brand?: string | null;
  brand_short?: string | null;
  only_in_stock?: boolean | null;
  without_folder?: boolean | null;
  without_barcode?: boolean | null;
  without_address?: boolean | null;
  with_address_debt?: boolean | null;
  only_buffer_stock?: boolean | null;
  without_placed_stock?: boolean | null;
  multi_cell_only?: boolean | null;
  without_image?: boolean | null;
  without_props?: boolean | null;
  brand_ids?: number[] | null;
  retail_range?: number[] | null;
  description?: string | null;
  withLastProvider?: boolean | null;
  withStock?: boolean | null;
  folders_id?: number[] | null;
  folder_id?: number;
  properties?: { property_id: number; values: string[] }[] | null;
  car_id?: number | null;
  default_warehouse_id?: number | null;
  sort_active?: string | null;
  sort_direction?: string | null;
  limit?: number | null;
  offset?: number | null;
}

export interface SearchWarehouseCellDto {
  warehouseId: number;
  code?: string | null;
  includeInactive?: boolean | null;
}

export interface CreateWarehouseCellDto {
  warehouseId: number;
  code: string;
  sortOrder?: number | null;
}

export interface UpdateWarehouseCellDto {
  id: number;
  isActive?: boolean | null;
  sortOrder?: number | null;
}

export interface SearchStockCellBalanceDto {
  warehouseId: number;
  productId?: number | null;
  cellId?: number | null;
  includeZero?: boolean | null;
  includeVirtual?: boolean | null;
}

export interface SearchStockCellMovementDto {
  productId?: number | null;
  warehouseId?: number | null;
  userId?: number | null;
  sourceType?: string | null;
  sourceId?: number | null;
  fromCellId?: number | null;
  toCellId?: number | null;
  note?: string | null;
  date_from?: Date | string | null;
  date_to?: Date | string | null;
  limit?: number | null;
  offset?: number | null;
}

export interface StockCellMovementCellRef {
  id: number;
  warehouseId: number;
  code: string;
  type: WarehouseCellType;
  isActive?: boolean;
  sortOrder?: number;
}

export interface StockCellMovementUserRef {
  id: number;
  name?: string | null;
  surname?: string | null;
  phone?: string | null;
}

export interface StockCellMovementRow {
  id: number;
  productId: number;
  warehouseId: number;
  fromCellId?: number | null;
  toCellId?: number | null;
  qty: number;
  sourceType?: string | null;
  sourceId?: number | null;
  userId?: number | null;
  note?: string | null;
  context?: Record<string, unknown> | null;
  createdAt: Date;
  fromCell?: StockCellMovementCellRef | null;
  toCell?: StockCellMovementCellRef | null;
  user?: StockCellMovementUserRef | null;
}

export interface StockCellMovementSearchResponse {
  data: StockCellMovementRow[];
  length: number;
}

export interface PlaceStockByCellDto {
  warehouseId: number;
  productId: number;
  fromCellId?: number | null;
  toCellId: number;
  qty: number;
  sourceType?: string | null;
  sourceId?: number | null;
}

export interface PickStockByCellDto {
  warehouseId: number;
  productId: number;
  fromCellId: number;
  qty: number;
  sourceType?: string | null;
  sourceId?: number | null;
}

export interface SetCellStockDto {
  warehouseId: number;
  productId: number;
  cellId: number;
  qty: number;
  sourceType?: string | null;
  sourceId?: number | null;
}

export interface ResolveVirtualCellOffsetDto {
  warehouseId: number;
  productId: number;
}

export interface CountShelfStockItemDto {
  productId: number;
  qty: number;
}

export interface CountShelfStockDto {
  warehouseId: number;
  cellId: number;
  items: CountShelfStockItemDto[];
  sourceType?: string | null;
  sourceId?: number | null;
}

export interface ResolveBarcodeDto {
  barcode: string;
  warehouseId: number;
  documentId?: number | null;
  context?: string | null;
  tecdocCandidate?: {
    dataSupplierId: number;
    articleNumber: string;
  };
}

export interface BarcodeResolvedProductCandidate {
  id: number;
  article: string;
  description: string;
  retail: number;
  price: number;
  brand: {
    id: number;
    description: string;
  };
  cellHints: string[];
  cellBalances?: ProductCellBalance[];
  images?: Image[];
}

export interface BarcodeTecDocCandidate {
  dataSupplierId: number;
  articleNumber: string;
  brandName: string;
  genericArticleName: string | null;
  imageUrl: string | null;
  gtins: string[];
}

export interface BarcodeProductMaterialization {
  status: string;
  enrichedExisting: boolean;
  aliasCreated: boolean;
}

export type BarcodeResolution =
  | {
      type: 'cell_match';
      barcode: string;
      cell: WarehouseCell;
    }
  | {
      type: 'single_product_match';
      barcode: string;
      product: BarcodeResolvedProductCandidate;
      source?: 'local' | 'tecdoc';
      materialization?: BarcodeProductMaterialization | null;
    }
  | {
      type: 'multi_product_match';
      barcode: string;
      candidates: BarcodeResolvedProductCandidate[];
    }
  | {
      type: 'tecdoc_multi_match';
      barcode: string;
      candidates: BarcodeTecDocCandidate[];
    }
  | {
      type: 'tecdoc_materialization_error';
      barcode: string;
      issueId: number | null;
      message: string;
    }
  | {
      type: 'no_match';
      barcode: string;
      candidates: BarcodeResolvedProductCandidate[];
    };

export interface ProductAddFolderDto {
  product_id: number;
  folder_id: number;
}

export interface ProductFolderBulkDto {
  product_ids: number[];
  folder_id: number;
}

export interface ProductRemoveAnalogueDto {
  product_id_1: number;
  product_id_2: number;
}

export interface Computer {
  labelPrinter: boolean;
  thermalPrinter: boolean;
  user: string;
}

export interface CellLabelDto {
  cell: string;
  quan: number;
  barcodeType: string;
  barcodeWidth: number;
  cellId?: number | null;
  cellCode?: string | null;
  copies?: number | null;
  warehouseId?: number | null;
  profileId?: number | string | null;
  profileCode?: string | null;
  labelProfileMode?: LabelProfileMode | null;
  agentName?: string | null;
  agentDeviceId?: string | null;
  target?: PrintTargetSelector | null;
}

export interface PriceTagDto {
  productId?: number | null;
  barcodeType: BarcodeTypeEnum;
  barcodeWidth: number;
  barcode: string | number;
  price: number | string;
  article: string;
  brand: string;
  cell?: string;
  quan: number;
  copies?: number | null;
  warehouseId?: number | null;
  profileId?: number | string | null;
  profileCode?: string | null;
  labelProfileMode?: LabelProfileMode | null;
  agentName?: string | null;
  agentDeviceId?: string | null;
  target?: PrintTargetSelector | null;
}

export interface ProductLabelPrintDto {
  productId?: number | null;
  barcode?: string;
  quanInPackage: number;
  quanPrint: number;
  copies?: number | null;
  warehouseId?: number | null;
  profileId?: number | string | null;
  profileCode?: string | null;
  labelProfileMode?: LabelProfileMode | null;
  agentName?: string | null;
  agentDeviceId?: string | null;
  target?: PrintTargetSelector | null;
}

export interface ProductInImportDoc extends ProductInDoc {
  priceNoNDS: number;
  retail: number;
  sum: number;
}

export interface ImportMoneyDoc {
  id: number;
  value: number;
  date: Date;
  passed: boolean;
  description: string;
  user: User;
  bank: Bank;
}

export interface MovingDoc {
  id: number;
  date_created: Date;
  passed: boolean;
  status?:
    | 'DRAFT'
    | 'PICKING'
    | 'READY_TO_DISPATCH'
    | 'IN_TRANSIT'
    | 'PARTIALLY_RECEIVED'
    | 'RECEIVED'
    | 'CANCELLED'
    | 'LEGACY_COMPLETED'
    | 'LEGACY_UNPOSTED';
  workflowVersion?: number;
  pickedAt?: Date;
  dispatchedAt?: Date;
  acceptedAt?: Date;
  cancelledAt?: Date;
  cancelReason?: string;
  progress?: Array<{
    movingProductId: number;
    product_id: number;
    plannedQuantity: number;
    pickedQuantity: number;
    dispatchedQuantity: number;
    receivedQuantity: number;
    resolvedQuantity: number;
  }>;
  exceptions?: any[];
  products: ProductInDoc[];
  warehouse_from: Warehouse;
  warehouse_to: Warehouse;
  user: User;
}

export interface MovingMoneyDoc {
  id: number;
  date_created: Date;
  date: Date;
  value: number;
  commission: number;
  passed: boolean;
  user: User;
  bank_from: Bank;
  bank_to: Bank;
}

export interface ClientCar {
  id: number;
  description: string | null;
  vin: string | null;
}

export interface ClientPhone {
  id: number;
  phone: string;
  isPrimary: boolean;
  createdAt: Date | string;
}

export interface UpdateClientDto {
  readonly id: number;
  readonly name?: string;
  readonly surname?: string;
  readonly phone?: string | null;
  readonly password?: string;
  readonly email?: string;
  readonly solvency?: number;
  readonly rating?: number;
  readonly smsNotificationsEnabled?: boolean;
  readonly paymentDelayDays?: number | null;
  readonly debtLimit?: number | null;
  readonly responsible_manager_user_id?: number | null;
}

export interface Client {
  id: number;
  name: string;
  surname: string;
  phone: string | null;
  solvency: number;
  rating: number;
  smsNotificationsEnabled: boolean;
  paymentDelayDays?: number | null;
  debtLimit?: number | null;
  responsibleManager?: UserRef | null;
  phones?: ClientPhone[];
  cars: ClientCar[] | undefined;
}

export interface ApiResponse {
  success: boolean;
  error: boolean;
  message: string | undefined;
}

export interface RetailDoc {
  id: number;
  user: User;
  date_created: Date | string;
  usd: number;
  eur: number;
  products?: ProductInRetailDoc[];
}

export interface ProductInRetailDoc {
  id?: number;
  product: Product;
  price: number;
  retail_doc?: RetailDoc;
}

export interface CreateRetailDocDto {
  products: {
    id: number;
    price: number;
  }[];
}
export interface UpdateRetailDocDto {
  id: number;
  products: {
    id: number;
    price: number;
  }[];
}
export interface SearchRetailDocDto {
  id?: number;
  product_ids?: number[];
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
  order?: string;
}

export interface ReturnToProviderDoc {
  id: number;
  date: Date;
  date_created: Date;
  passed: boolean;
  user: User;
  doc: ImportDoc;
  warehouse?: Warehouse | null;
  products: ProductInDoc[];
}

export interface ImportDoc {
  vatMode?: 'INCLUDED' | 'NONE' | null;
  goodsNetAmount?: number | string | null;
  goodsVatAmount?: number | string | null;
  goodsGrossAmount?: number | string | null;
  date: Date;
  date_created: Date;
  id: number;
  index: string | null;
  products: ProductInDoc[];
  contract: ContractWithProviderDoc;
  user: User;
  passed: boolean;
  delivery: number;
  warehouse: Warehouse;
}

export interface ReturnToWarehouseDoc {
  id: number;
  date: Date;
  date_created: Date;
  passed: boolean;
  fiscalizationStatus?: ReturnToWarehouseFiscalizationStatus;
  fiscalizationRequired?: boolean;
  fiscalizedAt?: Date | null;
  fiscalizedTotal?: number;
  fiscalizationError?: string | null;
  user: User;
  doc?: ExportDoc;
  shipment?: ShipmentByInvoiceDoc;
  warehouse?: Warehouse | null;
  warehouseId?: number | null;
  products: ProductInDoc[];
  source_invoice_id?: number | null;
  source_order_id?: number | null;
  return_total?: number;
  refunded_total?: number;
  refund_due_total?: number;
  refund_pending_total?: number;
  refund_docs?: ClientInvoiceRefundSummary[];
}

export type ReturnToWarehouseFiscalizationStatus =
  | 'NOT_REQUIRED'
  | 'PENDING'
  | 'FAILED'
  | 'PARTIAL'
  | 'SUCCESS';

export type ReturnToWarehouseFiscalAttemptStatus = 'PENDING' | 'FAILED' | 'SUCCESS';

export interface ReturnToWarehouseListRow {
  id: number;
  date: Date;
  date_created: Date;
  shipment_id?: number | null;
  warehouse_id?: number | null;
  source_warehouse_id?: number | null;
  source_warehouse?: string | null;
  fiscalization_status?: ReturnToWarehouseFiscalizationStatus;
  fiscalization_required?: boolean;
  fiscalized_at?: Date | null;
  fiscalized_total?: number;
  fiscalization_error?: string | null;
  manager: string;
  warehouse: string;
  sum: number;
  products: ProductInDoc[];
  source_invoice_id?: number | null;
  source_order_id?: number | null;
  return_total?: number;
  refunded_total?: number;
  refund_pending_total?: number;
  refund_due_total?: number;
}

export interface ReturnToWarehouseFiscalAttemptRow {
  id: number;
  status: ReturnToWarehouseFiscalAttemptStatus;
  attemptNo: number;
  sourcePaymentId?: number | null;
  sourceReceiptId?: number | null;
  sourceFiscalCode?: string | null;
  sum: number;
  cashSum: number;
  cardSum: number;
  requestPayload?: Record<string, unknown> | null;
  responsePayload?: Record<string, unknown> | null;
  error?: string | null;
  createdAt?: Date | null;
  fiscalizedAt?: Date | null;
}

export interface SupplierPaymentReturn {
  id: number;
  value: number;
  date: Date;
  date_created: Date;
  user: { id: number; name: string };
  manager_user_id?: number | null;
  manager_name?: string | null;
  cashbox_id: number;
  cashbox_name: string;
  money_day_id: number;
  comment: string;
}

export interface SettlementWithProviderDoc {
  id: number;
  value: number;
  date: Date;
  date_created: Date;
  passed: boolean;
  contract: ContractWithProviderDoc;
  user: User;
  commission: number;
  payment_type?: MoneyTypeEnum;
  comment?: string | null;
  request_id?: string | null;
  requestId?: string | null;
  cash_ledger_entry_id?: number | null;
  cashLedgerEntryId?: number | null;
  source_settlement_id?: number | null;
  sourceSettlementId?: number | null;
  returned_value?: number;
  returnable_value?: number;
  returns?: SupplierPaymentReturn[];
}

export interface ClientInvoiceItem {
  id?: number;
  invoice?: ClientInvoice;
  product: Product;
  quan: number;
  price: number;
}

export interface ClientInvoiceRefundSummary {
  id: number;
  date?: Date | null;
  date_created?: Date | null;
  invoice_id?: number | null;
  return_to_warehouse_id?: number | null;
  money_type: MoneyTypeEnum;
  value: number;
  executed_total?: number;
  refund_pending_total?: number;
  execution_status?: ClientInvoiceRefundExecutionStatus;
  execution_error?: string | null;
  executed_at?: Date | null;
  comment?: string | null;
}

export interface ClientInvoiceRefundAllocation {
  id: number;
  payment_id?: number | null;
  payment_receipt_id?: number | null;
  allocatedSum: number;
  createdAt?: Date | null;
}

export type ClientInvoiceRefundExecutionPolicy = 'AUTO_COMPLIANT' | 'MANUAL_CASH_OVERRIDE';

export type ClientInvoiceRefundExecutionStatus = 'PENDING' | 'PARTIAL' | 'SUCCESS' | 'FAILED';

export type ClientInvoiceRefundExecutionChannel =
  | 'FISCAL_CASH'
  | 'FISCAL_CASHLESS'
  | 'MANUAL_CASH'
  | 'MANUAL_BANK'
  | 'MANUAL_TERMINAL';

export interface ClientInvoiceRefundExecutionAttempt {
  id: number;
  payment_id?: number | null;
  payment_receipt_id?: number | null;
  cash_out_doc_id?: number | null;
  cashLedgerEntryId?: number | null;
  cash_ledger_entry_id?: number | null;
  sourcePaymentType?: MoneyTypeEnum | null;
  executionChannel: ClientInvoiceRefundExecutionChannel;
  status: ClientInvoiceRefundExecutionStatus;
  sum: number;
  sourceFiscalCode?: string | null;
  requestPayload?: Record<string, unknown> | null;
  responsePayload?: Record<string, unknown> | null;
  error?: string | null;
  executedAt?: Date | null;
  createdAt?: Date | null;
}

export interface ClientInvoiceRefundRow {
  id: number;
  request_id?: string | null;
  requestId?: string | null;
  date?: Date | null;
  date_created?: Date | null;
  invoice_id: number;
  order_id?: number | null;
  client_id?: number | null;
  user_id?: number | null;
  return_to_warehouse_id?: number | null;
  client_name?: string | null;
  client_surname?: string | null;
  manager?: string | null;
  money_type: MoneyTypeEnum;
  value: number;
  execution_policy?: ClientInvoiceRefundExecutionPolicy;
  executionPolicy?: ClientInvoiceRefundExecutionPolicy;
  execution_status?: ClientInvoiceRefundExecutionStatus;
  executionStatus?: ClientInvoiceRefundExecutionStatus;
  executed_total?: number;
  executedTotal?: number;
  execution_error?: string | null;
  executionError?: string | null;
  executed_at?: Date | null;
  executedAt?: Date | null;
  fiscalization_status?: 'NOT_REQUIRED' | 'PENDING' | 'SUCCESS' | 'FAILED';
  fiscalizationStatus?: 'NOT_REQUIRED' | 'PENDING' | 'SUCCESS' | 'FAILED';
  fiscalization_error?: string | null;
  fiscalizationError?: string | null;
  fiscalized_at?: Date | null;
  fiscalizedAt?: Date | null;
  refund_pending_total?: number;
  cash_out_doc_id?: number | null;
  cash_ledger_entry_id?: number | null;
  comment?: string | null;
  allowed_actions?: Record<
    'delete' | 'retry' | 'confirm_terminal' | 'fiscalize',
    PaymentActionDecision
  >;
}

export interface PaymentActionDecision {
  allowed: boolean;
  reason_code?: string | null;
  message?: string | null;
}

export interface PaymentCorrectionDecision extends PaymentActionDecision {
  mode?: 'PRE_FINALIZATION' | 'FISCAL' | 'POST_COLLECTION' | null;
  required_action?: 'REOPEN_SHIFT' | 'PROVIDER_VOID_OR_REFUND' | null;
  source_money_day_id?: number | null;
  source_collection_id?: number | null;
  default_cash_container_id?: number | null;
}

export interface ClientInvoiceRefundDoc extends ClientInvoiceRefundRow {
  allocations?: ClientInvoiceRefundAllocation[];
  execution_attempts?: ClientInvoiceRefundExecutionAttempt[];
}

export interface ClientInvoice {
  id: number;
  date_created: Date;
  date: Date;
  comment?: string;
  total: number;
  order?: Order;
  client: Client;
  user: User;
  org?: Organization;
  orgBankAccount?: OrgBankAccount;
  items: ClientInvoiceItem[];
  paid_total?: number;
  payment_status?: 'UNPAID' | 'PARTIALLY_PAID' | 'FULLY_PAID';
  returned_total?: number;
  collectible_total?: number;
  refunded_total?: number;
  refund_pending_total?: number;
  refund_due_total?: number;
  has_returns?: boolean;
}

export interface ClientInvoicePaymentLink {
  id: number;
  invoice_id: number;
  amount: number;
  currency: string;
  status: 'CREATED' | 'PROCESSING' | 'PAID' | 'FAILED' | 'EXPIRED' | 'CANCELED';
  url: string;
  liqpay_order_id: string;
  expires_at: Date;
  payment_id?: number;
  fiscalization_status?: 'NOT_ATTEMPTED' | 'PENDING' | 'SUCCESS' | 'FAILED';
  fiscalization_error?: string | null;
}

export interface ClientInvoiceLog {
  id: number;
  action: 'CREATE' | 'UPDATE' | 'DELETE';
  before?: Record<string, unknown> | null;
  after?: Record<string, unknown> | null;
  createdAt: Date;
  user?: User;
}

export interface ClientInvoiceListRow {
  id: number;
  date_created: Date;
  date: Date;
  comment?: string;
  total: number;
  order_id?: number;
  client_id: number;
  user_id: number;
  org_id?: number;
  org_bank_account_id?: number;
  client_name: string;
  client_surname: string;
  client_phone?: string;
  manager: string;
  org_name?: string;
  org_iban?: string;
  paid_total?: number;
  payment_status?: 'UNPAID' | 'PARTIALLY_PAID' | 'FULLY_PAID';
  returned_total?: number;
  collectible_total?: number;
  refunded_total?: number;
  refund_pending_total?: number;
  refund_due_total?: number;
  has_returns?: boolean;
  shipment_status?: 'UNSHIPPED' | 'PARTIALLY_SHIPPED' | 'FULLY_SHIPPED';
}

export interface ClientInvoicePaymentRow {
  id: number;
  invoice_id: number;
  invoice_number: number;
  value: number;
  payment_type: MoneyTypeEnum;
  cash_request_id?: string | null;
  request_id?: string | null;
  initial_cash_ledger_entry_id?: number | null;
  requestId?: string | null;
  initialCashLedgerEntryId?: number | null;
  skip_fiscalization?: boolean;
  receipt_status?: 'PENDING' | 'FAILED' | 'SUCCESS' | null;
  fiscal_attempts?: number | null;
  fiscal_failure_count?: number | null;
  fiscal_error?: string | null;
  fiscal_code?: string | null;
  is_fiscalized?: boolean;
  is_corrected_source?: boolean;
  is_correction_replacement?: boolean;
  correction_id?: number | null;
  correction_group_id?: string | null;
  correction_reason?: string | null;
  correction_status?: 'PENDING' | 'SUCCESS' | 'PARTIAL' | 'FAILED' | null;
  correction_role?: 'SOURCE' | 'REPLACEMENT' | 'REVERSAL' | 'NONE' | null;
  is_corrected?: boolean;
  date: Date;
  date_created: Date;
  user_id?: number;
  manager?: string;
  client_id?: number;
  client_name?: string;
  client_surname?: string;
  client_phone?: string;
  allowed_actions?: {
    edit: PaymentActionDecision;
    delete: PaymentActionDecision;
    correct: PaymentCorrectionDecision;
    retry_correction: PaymentActionDecision;
  };
}

export type ClientInvoicePayment = ClientInvoicePaymentRow;

export interface ClientInvoicePaymentCorrectionResult {
  correction_id?: number | null;
  request_id?: string | null;
  mode?: 'PRE_FINALIZATION' | 'FISCAL' | 'POST_COLLECTION';
  action?: 'REPLACE' | 'CANCEL';
  source_payment_id: number | null;
  source_receipt_id: number | null;
  reversal_attempt_id: number | null;
  new_payment_id: number | null;
  new_receipt_id: number | null;
  status: 'PENDING' | 'SUCCESS' | 'PARTIAL' | 'FAILED';
  error: string | null;
}

export interface ClientInvoicePaymentReceiptRow {
  id: number;
  paymentId?: number;
  invoiceId?: number;
  status: 'PENDING' | 'FAILED' | 'SUCCESS';
  attempts?: number;
  failureCount?: number;
  fiscalId?: number | null;
  fiscalCode?: string | null;
  fiscalQR?: string | null;
  error?: string | null;
  coefficient?: number;
  total?: number;
  fiscalizedAt?: Date | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  receiptSnapshot?: Record<string, unknown> | null;
  receiptSnapshotValidation?: ReceiptSnapshotValidation | null;
  is_fiscalized?: boolean;
}

export interface ReceiptSnapshotValidation {
  isComplete: boolean;
  missingFields: string[];
  warnings: string[];
}

export interface ShipmentByInvoiceItem {
  id?: number;
  shipment?: ShipmentByInvoiceDoc;
  product: Product;
  quan: number;
  price: number;
}

export interface ShipmentByInvoiceDoc {
  id: number;
  date_created: Date;
  date: Date;
  passed: boolean;
  invoice: ClientInvoice;
  warehouse: Warehouse;
  user: User;
  products: ShipmentByInvoiceItem[];
  sum: number;
  credit_warning?: ClientDebtWarning | null;
  warnings?: string[];
}

export interface ShipmentByInvoiceListRow {
  id: number;
  invoice_id: number;
  date: Date;
  date_created: Date;
  passed: boolean;
  warehouse_id: number;
  user_id: number;
  client_id: number;
  warehouse: string;
  manager: string;
  client_name?: string;
  client_surname?: string;
  client_phone?: string;
  client?: string | null;
  sum: number;
  products: ProductInDoc[];
}

export interface SearchShipmentByInvoiceDto {
  id?: number;
  order_id?: number;
  invoice_id?: number;
  date_from?: Date;
  date_to?: Date;
  client_id?: number;
  user_id?: number;
  warehouse_id?: number;
  product_id?: number;
  product_ids?: number[];
  search_query?: string;
  limit?: number;
  offset?: number;
}

export interface ContractWithProviderDoc {
  id: number;
  provider: Provider | string;
  org: Organization | string;
  number: string;
  start_date: Date;
  end_date: Date;
  day_limit: number;
  credit_limit: number;
  active: boolean;
}

export interface ContractWithProviderReportRow extends ContractWithProviderDoc {
  debt: number;
  turnover_current: number;
  turnover_prev: number;
  returns_current: number;
  returns_prev: number;
  fifo_due_today: number;
  fifo_due_tomorrow: number;
}

export interface ContractWithProviderReconciliationRow extends ContractWithProviderDoc {
  imports: number;
  returns: number;
  settlements: number;
  balance: number;
  month: number;
  year: number;
}

export type SupplierProviderCode =
  | 'AUTOTECHNICS'
  | 'OMEGA'
  | 'UNIQTRADE'
  | 'BUSMARKET'
  | 'VLADISLAV'
  | 'MASLOTOCHKA'
  | 'OILPARTS'
  | 'TURBOAM'
  | 'LIAMOTORS'
  | 'AUTOORIGINAL'
  | 'ZENIT'
  | 'ELIT'
  | 'AUTONOVA'
  | 'VESNA'
  | 'ASIA_PARTS'
  | 'OILTIME'
  | 'KOREA_PARTS'
  | 'ST_AUTO'
  | 'DRAGON_PARTS'
  | 'TEHNOMIR'
  | 'INTERCARS'
  | 'SCARPARTS'
  | 'BASTION';

export type SupplierTransportType = 'TOKEN_HTTP' | 'PLAYWRIGHT_BROWSER' | 'EMAIL_MAILBOX';

export type SupplierIntegrationHealthStatus = 'UNKNOWN' | 'OK' | 'AUTH_FAILED' | 'REQUEST_FAILED';

export type SupplierPriceImportParserCode =
  | 'BASTION_CSV_V1'
  | 'AUTOTECHNICS_CSV_V1'
  | 'OMEGA_PRICELIST_JSON_V1'
  | 'UNIQTRADE_CSV_V1'
  | 'BUSMARKET_JSON_V1'
  | 'VLADISLAV_CSV_V1'
  | 'MASLOTOCHKA_PRICE_V1'
  | 'OILPARTS_XLS_V1'
  | 'TURBOAM_JSON_V1'
  | 'LIAMOTORS_XLSX_V1'
  | 'AUTOORIGINAL_XLSX_V1'
  | 'ZENIT_PRICE_V1'
  | 'ELIT_STOCK_CSV_ZIP_V1'
  | 'AUTONOVA_STOCK_XLSX_ZIP_V1'
  | 'VESNA_STOCK_XLSX_V1'
  | 'ASIA_PARTS_XLSX_V1'
  | 'OILTIME_XLSX_V1'
  | 'KOREA_PARTS_XLSX_V1'
  | 'ST_AUTO_CSV_V1'
  | 'DRAGON_PARTS_XLSX_V1'
  | 'TEHNOMIR_STOCK_CSV_V1'
  | 'INTERCARS_STOCK_PRICE_CSV_ZIP_V1'
  | 'SCARPARTS_STOCK_XLS_ZIP_V1';

export type SupplierPriceImportTrigger = 'MANUAL' | 'CRON' | 'MAILBOX';

export type SupplierPriceImportStatus = 'RUNNING' | 'SUCCESS' | 'FAILED';

export type SupplierPriceQuantityQualifier = 'EXACT' | 'LOWER_BOUND';

export interface SupplierIntegrationAccount {
  id: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  transportType: SupplierTransportType;
  isActive: boolean;
  lastHealthStatus: SupplierIntegrationHealthStatus;
  lastHealthAt?: Date | null;
  lastHealthMessage?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpsertSupplierIntegrationAccountDto {
  contract_id: number;
  provider_code: SupplierProviderCode;
  login?: string;
  password?: string;
  csv_login?: string;
  csv_password?: string;
  external_contract_id?: string;
  is_active?: boolean;
}

export interface SupplierIntegrationHealthResult {
  ok: boolean;
  providerCode: SupplierProviderCode;
  contractId: number;
  status: SupplierIntegrationHealthStatus;
  checkedAt?: Date | null;
  message?: string;
}

export type SupplierProductInfoCacheState = 'fresh' | 'stale' | 'miss';

export interface SupplierProductInfoAttribute {
  name: string;
  value: string;
}

export interface SupplierProductInfoRelation {
  brand: string;
  article: string;
  name?: string | null;
}

export interface SupplierProductInfo {
  id?: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  brand: string;
  article: string;
  normalizedBrand: string;
  normalizedArticle: string;
  name?: string | null;
  attributes: SupplierProductInfoAttribute[];
  images: string[];
  analogues: SupplierProductInfoRelation[];
  oemNumbers: SupplierProductInfoRelation[];
  rawPayload?: Record<string, unknown> | null;
  fetchedAt?: Date | null;
  expiresAt?: Date | null;
  cacheState: SupplierProductInfoCacheState;
}

export type SupplierProductInfoLoadTrigger = 'MANUAL' | 'CRON';
export type SupplierProductInfoLoadMode = 'NATIVE' | 'FALLBACK';
export type SupplierProductInfoLoadStatus =
  | 'RUNNING'
  | 'SUCCESS'
  | 'FAILED'
  | 'PARTIAL'
  | 'CANCELLED';
export type SupplierProductInfoLoadItemStatus = 'SUCCESS' | 'FAILED' | 'SKIPPED_FRESH';

export interface SupplierProductInfoLoadConfig {
  id: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  mode?: SupplierProductInfoLoadMode;
  isEnabled: boolean;
  autoRunEnabled: boolean;
  runAtTime: string;
  windowStartTime: string;
  windowEndTime: string;
  concurrency: number;
  sourceContractIds?: number[];
  createdAt: Date;
  updatedAt: Date;
}

export interface UpsertSupplierProductInfoLoadConfigDto {
  contract_id: number;
  provider_code: SupplierProviderCode;
  is_enabled: boolean;
  auto_run_enabled: boolean;
  run_at_time?: string;
  window_start_time?: string;
  window_end_time?: string;
  concurrency: number;
}

export interface UpsertSupplierProductInfoLoadFallbackConfigDto {
  price_contract_id: number;
  price_provider_code: SupplierProviderCode;
  is_enabled: boolean;
  auto_run_enabled: boolean;
  run_at_time?: string;
  window_start_time?: string;
  window_end_time?: string;
  concurrency: number;
  source_contract_ids: number[];
}

export interface SupplierProductInfoLoadRun {
  id: number;
  accountId: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  mode: SupplierProductInfoLoadMode;
  trigger: SupplierProductInfoLoadTrigger;
  status: SupplierProductInfoLoadStatus;
  startedAt: Date;
  finishedAt?: Date | null;
  message?: string | null;
  queuedCount: number;
  successCount: number;
  failedCount: number;
  skippedFreshCount: number;
}

export interface SupplierProductInfoLoadRunItem {
  id: number;
  runId: number;
  supplierPriceItemId: number;
  brand: string;
  article: string;
  status: SupplierProductInfoLoadItemStatus;
  startedAt: Date;
  finishedAt?: Date | null;
  durationMs?: number | null;
  cacheState?: SupplierProductInfoCacheState | null;
  cacheId?: number | null;
  infoContractId?: number | null;
  infoProviderCode?: SupplierProviderCode | null;
  message?: string | null;
  attributeCount: number;
  imageCount: number;
  analogueCount: number;
  oeNumberCount: number;
}

export interface SupplierProductInfoLoadRunItemsResponse {
  data: SupplierProductInfoLoadRunItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface SupplierProductInfoLoadSourceOption {
  contractId: number;
  providerCode: SupplierProviderCode;
  providerName: string;
  orgId?: number | null;
  orgName?: string | null;
  contractNumber?: string | null;
}

export interface SupplierProductInfoLoadSource {
  contractId: number;
  providerCode: SupplierProviderCode;
  mode: SupplierProductInfoLoadMode;
  providerName: string;
  orgId?: number | null;
  orgName?: string | null;
  contractNumber?: string | null;
  config: SupplierProductInfoLoadConfig;
  infoSourceOptions?: SupplierProductInfoLoadSourceOption[];
  latestRun?: SupplierProductInfoLoadRun | null;
}

export type SupplierProcurementOrderStatus =
  | 'CREATED'
  | 'SUBMITTED'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'FAILED'
  | 'CANCELLED';

export type SupplierProcurementDocumentType =
  | 'ORDER'
  | 'INVOICE'
  | 'WAYBILL'
  | 'ATTACHMENT'
  | 'OTHER';

export interface SupplierProcurementItemInputDto {
  brand: string;
  article: string;
  quantity: number;
  price?: number | null;
  name?: string | null;
}

export interface CreateSupplierProcurementOrderDto {
  items: SupplierProcurementItemInputDto[];
  comment?: string | null;
  external_reference?: string | null;
}

export interface SupplierProcurementOrder {
  id: number;
  accountId: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  externalOrderId: string;
  status: SupplierProcurementOrderStatus;
  number?: string | null;
  totalAmount?: number | null;
  currency?: string | null;
  comment?: string | null;
  lastSyncedAt?: Date | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface SupplierProcurementDocument {
  id: number;
  orderId: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  externalDocumentId: string;
  type: SupplierProcurementDocumentType;
  number?: string | null;
  issuedAt?: Date | null;
  amount?: number | null;
  currency?: string | null;
  fileName?: string | null;
  contentType?: string | null;
  downloadedAt?: Date | null;
}

export interface SupplierPriceImportConfig {
  id: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  parserCode: SupplierPriceImportParserCode;
  isEnabled: boolean;
  autoRunEnabled: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpsertSupplierPriceImportConfigDto {
  contract_id: number;
  provider_code: SupplierProviderCode;
  is_enabled: boolean;
  auto_run_enabled: boolean;
}

export interface SupplierPriceImportRun {
  id: number;
  contractId: number;
  providerCode: SupplierProviderCode;
  parserCode: SupplierPriceImportParserCode;
  trigger: SupplierPriceImportTrigger;
  status: SupplierPriceImportStatus;
  startedAt: Date;
  finishedAt?: Date | null;
  rowCount: number;
  itemCount: number;
  stockRowCount: number;
  createdWarehouseCount: number;
  rawFileName?: string | null;
  rawMimeType?: string | null;
  rawSizeBytes?: number | null;
  message?: string | null;
  warnings?: string[];
}

export interface SupplierPriceStock {
  providerWarehouseId: number;
  warehouse: string;
  quantity: number;
  quantityQualifier: SupplierPriceQuantityQualifier;
  rawQuantity?: string | null;
}

export interface SupplierPriceItem {
  id: number;
  brand: string;
  article: string;
  externalProductId?: string | null;
  name?: string | null;
  price?: number | null;
  barcode?: string | null;
  salesOrderMultiple?: number | null;
  stocks: SupplierPriceStock[];
}

export interface SupplierPriceItemsResponse {
  data: SupplierPriceItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface SupplierPriceMailboxAttachment {
  filename: string;
  mimeType?: string | null;
  size: number;
  attachmentId?: string | null;
}

export interface SupplierPriceMailboxMessage {
  id: string;
  threadId?: string | null;
  from?: string | null;
  to?: string | null;
  subject?: string | null;
  date?: string | null;
  labelIds: string[];
  attachments: SupplierPriceMailboxAttachment[];
}

export interface SupplierPriceMailboxStatus {
  mailbox: string;
  historyId?: string | null;
  labels: {
    newLabelId: string;
    processedLabelId: string;
    errorLabelId?: string | null;
  };
  latestMessage?: SupplierPriceMailboxMessage | null;
}

export interface SupplierPriceMailboxPollResult {
  dryRun: boolean;
  processedCount: number;
  messages: SupplierPriceMailboxMessage[];
}

export interface SupplierPriceMailboxImportResult {
  dryRun: boolean;
  message?: SupplierPriceMailboxMessage | null;
  run?: SupplierPriceImportRun | null;
}

export type ContractLedgerRowType = 'import' | 'return' | 'settlement';

export interface ContractLedgerRow {
  date: Date | string;
  type: ContractLedgerRowType;
  doc_id: number;
  amount: number;
  balance_after: number;
  source_settlement_id?: number | null;
  credit_entry_id?: number;
  decision_id?: number | null;
  entry_kind?: 'LEGACY' | 'ACCEPTANCE' | 'REVERSAL' | 'CORRECTION';
}

export interface ContractLedgerResponse {
  opening_balance: number;
  closing_balance: number;
  rows: ContractLedgerRow[];
}

export interface ProfitReportPeriod {
  requested_from: string;
  requested_to: string;
  warning?: string;
}

export interface ProfitReportMetrics {
  sales_qty: number;
  return_qty: number;
  net_qty: number;
  revenue: number;
  cogs: number;
  profit: number;
  margin_percent: number;
}

export interface ProfitReportManagerSummaryItem extends ProfitReportMetrics {
  manager_id: number;
  manager: string;
  closed_invoices_count: number;
}

export interface ProfitReportManagerSummaryTotals extends ProfitReportMetrics {
  closed_invoices_count: number;
}

export interface ProfitReportLegacyManagerSummaryItem extends ProfitReportMetrics {
  manager_id: number;
  manager: string;
  export_docs_count: number;
}

export interface ProfitReportLegacyManagerSummaryTotals extends ProfitReportMetrics {
  export_docs_count: number;
}

export interface ProfitReportEstimated<TItem, TTotals> {
  basis: string;
  note: string;
  items: TItem[];
  totals: TTotals;
}

export interface ProfitReportManagerSummaryResponse {
  period: ProfitReportPeriod;
  items: ProfitReportManagerSummaryItem[];
  totals: ProfitReportManagerSummaryTotals;
  estimated: ProfitReportEstimated<
    ProfitReportManagerSummaryItem,
    ProfitReportManagerSummaryTotals
  >;
}

export interface ProfitReportManagerMonthForecastPeriod {
  month_from: string;
  actual_to: string;
  forecast_to: string;
  warning?: string;
}

export interface ProfitReportManagerMonthForecastMeta {
  method: 'linear_calendar_day_run_rate';
  elapsed_days: number;
  total_days: number;
}

export interface ProfitReportManagerMonthForecastItem {
  manager_id: number;
  manager: string;
  actual_profit: number;
  month_end_profit: number;
  delta_profit: number;
}

export interface ProfitReportManagerMonthForecastTotals {
  actual_profit: number;
  month_end_profit: number;
  delta_profit: number;
}

export interface ProfitReportManagerMonthForecastResponse {
  period: ProfitReportManagerMonthForecastPeriod;
  forecast: ProfitReportManagerMonthForecastMeta;
  items: ProfitReportManagerMonthForecastItem[];
  totals: ProfitReportManagerMonthForecastTotals;
}

export interface ProfitReportLegacyManagerSummaryResponse {
  period: ProfitReportPeriod;
  items: ProfitReportLegacyManagerSummaryItem[];
  totals: ProfitReportLegacyManagerSummaryTotals;
}

export interface ProfitReportProductSummaryFilters {
  user_id?: number;
}

export interface ProfitReportProductSummaryDocument {
  event_type: 'SALE_CLOSE' | 'RETURN';
  date: string;
  invoice_id: number | null;
  shipment_ids: number[];
  return_doc_id: number | null;
}

export interface ProfitReportProductSummaryItem extends ProfitReportMetrics {
  sale_date_from: string | null;
  sale_date_to: string | null;
  product_id: number;
  article: string | null;
  product: string | null;
  manager_id: number;
  manager: string;
  sale_dates: string[];
  return_dates: string[];
  documents: ProfitReportProductSummaryDocument[];
}

export interface ProfitReportProductSummaryResponse {
  period: ProfitReportPeriod;
  filters: ProfitReportProductSummaryFilters;
  items: ProfitReportProductSummaryItem[];
  totals: ProfitReportMetrics;
  estimated: ProfitReportEstimated<ProfitReportProductSummaryItem, ProfitReportMetrics>;
}

export interface ClientProfileReportMonth {
  month_key: string;
  month_label: string;
  is_current: boolean;
  turnover: number;
  profit: number;
  orders_count: number;
  markup_percent: number;
}

export interface ClientProfileReportSummary {
  avg_markup_percent: number;
  avg_orders_per_month: number;
  avg_profit_per_month: number;
  current_profit: number;
  current_orders_count: number;
  current_orders_debt: number;
  current_prepayment_balance: number;
  overdue_debt: number;
}

export interface ClientProfileReportProduct {
  product_id: number;
  product: string;
  article: string;
  sales_qty: number;
  return_qty: number;
  net_qty: number;
  turnover: number;
  profit: number;
}

export interface ClientProfileReportResponse {
  client_id: number;
  months: ClientProfileReportMonth[];
  summary: ClientProfileReportSummary;
  period: { date_from: string; date_to: string; months_count: number };
  top_products: ClientProfileReportProduct[];
  incomplete_cost_data: boolean;
}

export type ClientCallDirection = 'from_client' | 'to_client' | 'unknown';

export interface ClientCallHistoryItem {
  id: string;
  callId: string | null;
  callDate: string | null;
  callDateLabel: string;
  caller: string | null;
  destination: string | null;
  clientPhone: string | null;
  managerNumber: string | null;
  direction: ClientCallDirection;
  directionLabel: string;
  status: string | null;
  statusLabel: string;
  durationSec: number;
  durationLabel: string;
  recordingUrl: string | null;
  hasRecording: boolean;
}

export interface ClientCallHistoryResponse {
  client_id: number;
  phones: string[];
  from: string;
  to: string;
  items: ClientCallHistoryItem[];
}

export interface ClientDebtSummary {
  client_id: number;
  payment_delay_days: number | null;
  debt_limit: number | null;
  shipped_total: number;
  returned_total: number;
  paid_total: number;
  refunded_total: number;
  shipped_collectible: number;
  net_credit: number;
  current_debt: number;
  prepayment_balance: number;
  overdue_debt: number;
  overdue_since: string | null;
}

export interface ClientDebtWarning {
  code: 'CLIENT_DEBT_WARNING';
  client_id: number;
  messages: string[];
  shipment_amount: number;
  current_debt: number;
  projected_debt: number;
  debt_limit: number | null;
  exceeded_amount: number;
  payment_delay_days: number | null;
  overdue_debt: number;
  overdue_since: string | null;
  prepayment_balance: number;
  summary?: ClientDebtSummary;
}

export interface WriteOffMoneyDoc {
  id: number;
  value: number;
  date: Date;
  passed: boolean;
  description: string;
  user: User;
  bank: Bank;
  commission: number;
}

export interface WriteOffProductsRow {
  id?: number;
  product: Product;
  quantity: number;
  price?: number | null;
}

export interface WriteOffProductsDoc {
  id: number;
  date: Date;
  date_created: Date;
  passed: boolean;
  reason?: string | null;
  comment?: string | null;
  user: User;
  warehouse: Warehouse;
  rows: WriteOffProductsRow[];
}

export interface SurplusProductsRow {
  id?: number;
  product: Product;
  quantity: number;
  price?: number | null;
}

export interface SurplusProductsDoc {
  id: number;
  date: Date;
  date_created: Date;
  passed: boolean;
  reason?: string | null;
  comment?: string | null;
  user: User;
  warehouse: Warehouse;
  rows: SurplusProductsRow[];
}

export interface RegradingProductsRow {
  id?: number;
  fromProduct?: Product;
  fromProductId: number;
  toProduct?: Product;
  toProductId: number;
  quantity: number;
  price?: number | null;
}

export interface RegradingProductsDoc {
  id: number;
  date: Date;
  date_created: Date;
  passed: boolean;
  reason?: string | null;
  comment?: string | null;
  user: User;
  warehouse: Warehouse;
  rows: RegradingProductsRow[];
}

export interface FiscalSearchDto {
  readonly id?: number;
  readonly name?: string;
  readonly token?: string;
  readonly type?: FiscalTypeEnum;
  readonly isSessionOpen?: boolean;
  readonly limit?: number;
  readonly offset?: number;
}

export interface FiscalCreateDto {
  readonly name: string;
  readonly address?: string;
  readonly type?: FiscalTypeEnum;
  readonly sellerDisplayName?: string;
  readonly unitDisplayName?: string;
  readonly displayTaxIdLabel?: string;
  readonly displayTaxIdValue?: string;
  readonly fullAddress?: string;
  readonly prroFiscalNumber?: string;
  readonly printStaticTaxLine?: boolean;
  readonly staticTaxLabel?: string;
  readonly staticTaxLetter?: string;
  readonly isTestMode?: boolean;
  readonly printLogoOnFiscalReceipt?: boolean;
}

export interface FiscalUpdateDto {
  readonly id: number;
  readonly name?: string;
  readonly address?: string;
  readonly type?: FiscalTypeEnum;
  readonly token?: string;
  readonly sellerDisplayName?: string;
  readonly unitDisplayName?: string;
  readonly displayTaxIdLabel?: string;
  readonly displayTaxIdValue?: string;
  readonly fullAddress?: string;
  readonly prroFiscalNumber?: string;
  readonly printStaticTaxLine?: boolean;
  readonly staticTaxLabel?: string;
  readonly staticTaxLetter?: string;
  readonly isTestMode?: boolean;
  readonly printLogoOnFiscalReceipt?: boolean;
}

export interface FiscalCollectDto {
  readonly id: number;
  readonly sum: number;
}

export interface FiscalAddMoneyDto {
  readonly id: number;
  readonly sum: number;
}

export interface Eshop {
  id: number;
  description: string;
}

export interface EshopLink {
  id: number;
  link: string;
  eshop?: Eshop;
}

export interface Article {
  id: number;
  article: string;
  articleTrim: string;
  product?: Product;
}

export interface EshopCreateDto {
  description: string;
}

export interface EshopUpdateDto {
  id: number;
  description?: string;
}

export interface EshopSearchDto {
  id?: number;
  description?: string;
  order?: string;
  limit?: number;
  offset?: number;
}

export interface EshopCreateLinkDto {
  link: string;
  eshop_id: number;
}

export interface EshopUpdateLinkDto {
  id: number;
  link?: string;
  eshop_id?: number;
}

export interface EshopLinkToProductDto {
  link_id: number;
  product_id: number;
}

export interface EshopSearchLinksDto {
  id?: number;
  product_id?: number;
  eshop_id?: number;
  limit?: number;
  offset?: number;
  order?: string;
}

export interface CreateFolderDto {
  readonly description: string;
  readonly parentFolderId?: number;
  image?: string;
}

export interface UpdateFolderDto {
  readonly id: number;
  readonly description?: string;
  image?: string;
  public?: boolean;
}

export interface MoveFolderDto {
  readonly id: number;
  readonly parentFolderId: number | null;
  readonly position: number;
}

export interface FolderProductImage {
  name: string;
  productId: number;
  productDescription: string;
}

export interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  image: string;
  id: number;
  level: number;
}
export interface BuyDoc {
  overdue?: boolean;
  id: number;
  workspaceVersion?: number;
  expectedAtPrecision?: 'DATE' | 'DATETIME';
  date_created: Date;
  date: Date;
  date_expected: Date;
  status: BuyDocStatus;
  cancellation_reason?: string | null;
  provider: Provider | string;
  contract?: ContractWithProviderDoc | null;
  contract_id?: number;
  contract_number?: string;
  user: User | string;
  products: ProductInDoc[];
  warehouse: Warehouse | string;
  deliveryWarehouse?: Warehouse | null;
  org: Organization | string;
  origin?: 'LEGACY' | 'CUSTOMER_ORDER' | 'MANUAL' | 'STOCK_REPLENISHMENT' | 'MIXED';
  origin_label?: string;
  source_order_id?: number | null;
  total_quantity?: number;
  received_quantity?: number;
  remaining_quantity?: number;
  client_quantity?: number;
  stock_quantity?: number;
}

export interface CreateBuyDocDto {
  date?: string;
  date_expected?: string;
  provider_id: number;
  contract_id: number;
  warehouse_id?: number;
  org_id?: number;
  products: {
    product_id: number;
    quan: string;
    price: number;
  }[];
}

export interface BuyDemandSuggestion {
  order_product_id: number;
  order_id: number;
  product_id: number;
  quantity: number;
  expected_at: string;
  preferred_provider: boolean;
}

export interface CreateAndOrderBuyDto {
  operation_id: string;
  date?: string;
  date_expected: string;
  provider_id: number;
  contract_id: number;
  warehouse_id: number;
  org_id: number;
  products: Array<{
    product_id: number;
    quantity: number;
    price: number;
    demands: Array<{ order_product_id: number; quantity: number }>;
  }>;
}

export interface UpdateBuyDocDto {
  products?: {
    id?: number;
    product_id: number;
    quan: string;
    price: number;
  }[];
  id: number;
  date?: string;
  date_expected?: string;
  provider_id?: number;
  contract_id?: number;
  status?: BuyDocStatus;
  warehouse_id?: number;
  delivery_warehouse_id?: number;
  org_id?: number;
}

export interface SearchBuyDocDto {
  np_ready?: boolean;
  overdue?: boolean;
  id?: number;
  source_order_id?: number;
  date_from?: string;
  date_to?: string;
  date_expected_from?: string;
  date_expected_to?: string;
  user_id?: number;
  status?: BuyDocStatus;
  warehouse_id?: number;
  org_id?: number;
  provider_id?: number;
  contract_id?: number;
  limit?: number;
  offset?: number;
  order?: string;
}

export interface ProductInDoc {
  vatRate?: number | string | null;
  netAmount?: number | string | null;
  vatAmount?: number | string | null;
  grossAmount?: number | string | null;
  id?: number;
  quan: number;
  price: number;
  price_current?: number;
  provider?: Provider;
  product: Product;
  sum: number;
  ordered_quan?: number;
  shipped_quan?: number;
  remaining_to_ship_quan?: number;
  waiting_supply_quan?: number;
  is_ready?: boolean;
  returned_quan?: number;
  return_doc_ids?: number[];
  reserved_quan?: number;
  picked_quan?: number;
  planned_quan?: number;
  ordered_open_quan?: number;
  received_quan?: number;
  uncovered_quan?: number;
}

export interface TabLink {
  // @todo delete this type?
  description: string;
  path: string;
}

export interface Link {
  path: string;
  description: string;
  children: Link[];
  createPath?: string;
  accent?: 'parts-selection';
  access: AccessEnum[];
}

export interface News {
  id: number;
  date: Date;
  img: string;
  title: string;
  text: string;
  active: boolean;
}

export interface CreateNewsDto {
  title: string;
  img: string;
  text: string;
  active?: boolean;
}

export interface UpdateNewsDto {
  id: number;
  title?: string;
  text?: string;
  img?: string;
  active?: boolean;
}

export interface SearchNewsDto {
  id?: number;
  date_from?: string | Date;
  date_to?: string | Date;
  title?: string;
  text?: string;
  limit?: number;
  offset?: number;
  order?: string;
  active?: boolean;
}

export type OrderSupplyStatus = 'WAITING_SUPPLY' | 'READY';
export type OrderProcurementStatus =
  | 'NOT_REQUIRED'
  | 'NEEDS_PROCESSING'
  | 'PARTIALLY_ORDERED'
  | 'WAITING_DELIVERY'
  | 'PARTIALLY_RECEIVED'
  | 'RECEIVED';
export type OrderReservationStatus = 'NONE' | 'PARTIAL' | 'FULL';
export type OrderPickingStatus = 'NOT_READY' | 'READY' | 'IN_PROGRESS' | 'PICKED';
export type OrderFulfillmentStatus =
  | 'PROCESSING'
  | 'WAITING_DELIVERY'
  | 'PARTIALLY_RECEIVED'
  | 'PUTAWAY_REQUIRED'
  | 'READY_TO_PICK'
  | 'PICKING'
  | 'READY_FOR_CLIENT'
  | 'PARTIALLY_SHIPPED'
  | 'COMPLETED'
  | 'CANCELLED';

export type OrderPaymentStatus = 'UNPAID' | 'PARTIALLY_PAID' | 'PAID';

export type OrderShipmentStatus = 'UNSHIPPED' | 'PARTIALLY_SHIPPED' | 'FULLY_SHIPPED';

export type OrderSource = 'CRM' | 'B2C' | 'PARTS_SELECTION';

export interface OrderStatusSummary {
  supply_status: OrderSupplyStatus;
  procurement_status: OrderProcurementStatus;
  reservation_status: OrderReservationStatus;
  picking_status: OrderPickingStatus;
  fulfillment_status: OrderFulfillmentStatus;
  payment_status: OrderPaymentStatus;
  shipment_status: OrderShipmentStatus;
  invoice_count: number;
  invoice_total: number;
  paid_total: number;
  returned_total: number;
  collectible_total: number;
  refunded_total: number;
  refund_pending_total: number;
  refund_due_total: number;
  has_returns: boolean;
}

export interface OrderReadiness {
  status: 'EMPTY' | 'UNSOURCED' | 'TRANSFER_PENDING' | 'DATE_MISSING' | 'IN_STOCK' | 'DATED';
  expected_at: string | null;
}

export interface Order {
  readiness?: OrderReadiness;
  expected_at_precision?: 'DATE' | 'DATETIME';
  id: number;
  date_created: Date;
  date_expected: Date;
  description: string;
  is_canceled?: boolean;
  date_canceled?: Date | null;
  cancel_reason?: string | null;
  source: OrderSource;
  status_summary?: OrderStatusSummary;
  delivery?: OrderDelivery;
  client_car: ClientCar;
  warehouse: Warehouse;
  client: Client;
  user: User;
  products: ProductInDoc[];
}

export type PartsSelectionDocumentStatus = 'DRAFT' | 'PARTIALLY_CONVERTED' | 'FULLY_CONVERTED';
export type PartsSelectionAvailabilityKind = 'LOCAL' | 'OTHER_LOCAL' | 'IN_CITY' | 'OUT_OF_CITY';

export interface PartsSelectionOfferItem {
  id?: number;
  product_id: number;
  provider_id?: number | null;
  provider_name?: string | null;
  price: number;
  quantity: number;
  product_description_snapshot: string;
  brand_snapshot: string;
  article_snapshot?: string | null;
  image_snapshot?: string | null;
  purchase_price_snapshot?: number | null;
  availability_snapshot?: string | null;
  availability_kind_snapshot?: PartsSelectionAvailabilityKind | null;
  delivery_eta_label_snapshot?: string | null;
  brand_rating_snapshot?: number | null;
  supplier_allocations?: PartsSelectionOfferSupplierAllocation[];
  warehouse_allocations?: PartsSelectionOfferWarehouseAllocation[];
}

export interface PartsSelectionOfferWarehouseAllocation {
  warehouse_id: number;
  warehouse_name?: string;
  quantity: number;
  purchase_price_snapshot?: number | null;
}

export interface PartsSelectionOfferSupplierAllocation {
  id?: number;
  provider_id: number;
  provider_name?: string | null;
  contract_id?: number | null;
  contract_number?: string | null;
  quantity: number;
  expected_at?: string | null;
  expected_date_is_estimated?: boolean;
  expected_time_is_estimated?: boolean;
  purchase_price_snapshot?: number | null;
  purchase_price_source?: 'PRICE_LIST' | 'MANUAL' | null;
  availability_snapshot?: string | null;
  availability_kind_snapshot?: Exclude<PartsSelectionAvailabilityKind, 'LOCAL'> | null;
  delivery_eta_label_snapshot?: string | null;
}

export interface PartsSelectionOfferGroup {
  id?: number;
  position: number;
  label: string;
  is_primary: boolean;
  items: PartsSelectionOfferItem[];
}

export interface PartsSelectionNeedOeItem {
  id?: number;
  position: number;
  description?: string | null;
  oe_number: string;
  catalog_source?: 'LAXIMO' | 'TECDOC' | null;
  number_kind?: 'OE' | 'ARTICLE' | null;
  brand?: string | null;
}

export interface PartsSelectionNeedItem {
  id?: number;
  position: number;
  need_text: string;
  quantity: number;
  oe_number?: string | null;
  oe_items: PartsSelectionNeedOeItem[];
  note?: string | null;
  converted_order_id?: number | null;
  converted_at?: Date | string | null;
  offer_groups: PartsSelectionOfferGroup[];
  learning_run_id?: number | null;
}

export interface PartsSelectionOrderLink {
  id: number;
  date_created?: Date | string | null;
  description?: string | null;
}

export interface PartsSelectionDocument {
  id: number;
  date_created: Date | string;
  date_updated: Date | string;
  status: PartsSelectionDocumentStatus;
  phone_snapshot?: string | null;
  vin_snapshot?: string | null;
  car_description_snapshot?: string | null;
  tecdoc_linkage_target_id?: number | null;
  tecdoc_vehicle_description?: string | null;
  comment?: string | null;
  manager_user_id?: number | null;
  manager_user_name?: string | null;
  client?: Client | null;
  client_car?: ClientCar | null;
  need_items: PartsSelectionNeedItem[];
  created_orders: PartsSelectionOrderLink[];
}

export interface PartsSelectionDocumentListItem {
  id: number;
  date_created: Date | string;
  date_updated: Date | string;
  status: PartsSelectionDocumentStatus;
  phone_snapshot?: string | null;
  vin_snapshot?: string | null;
  car_description_snapshot?: string | null;
  tecdoc_linkage_target_id?: number | null;
  tecdoc_vehicle_description?: string | null;
  comment?: string | null;
  manager_user_id?: number | null;
  manager_user_name?: string | null;
  client_id?: number | null;
  client_name?: string | null;
  items_count: number;
  converted_items_count: number;
  created_orders_count: number;
}

export interface PartsSelectionDocumentListResponse {
  items: PartsSelectionDocumentListItem[];
  total: number;
  limit: number;
  offset: number;
}

export type TecDocCatalogResolveStatus = 'RESOLVED' | 'CHOICE_REQUIRED' | 'MANUAL_REQUIRED';

export type TecDocCatalogResolveReason =
  | 'VIN_INVALID'
  | 'VIN_NOT_FOUND'
  | 'ENGINE_NOT_FOUND'
  | 'TECDOC_NOT_FOUND'
  | 'PROVIDER_UNAVAILABLE';

export interface TecDocCatalogManufacturer {
  id: number;
  name: string;
  count: number;
}

export interface TecDocCatalogModelSeries {
  id: number;
  name: string;
  count: number;
  beginYearMonth?: string | number;
  endYearMonth?: string | number;
}

export interface TecDocCatalogVehicle {
  linkageTargetId: number;
  description: string;
  manufacturerId?: number | null;
  manufacturerName?: string | null;
  modelSeriesName?: string | null;
  beginYearMonth?: string | null;
  endYearMonth?: string | null;
  bodyStyle?: string | null;
  fuelType?: string | null;
  engineType?: string | null;
  engineCodes: string[];
  capacityLabel?: string | null;
  powerLabel?: string | null;
}

export interface TecDocCatalogResolveVehiclesResponse {
  status: TecDocCatalogResolveStatus;
  reason: TecDocCatalogResolveReason | null;
  vehicles: TecDocCatalogVehicle[];
}

export interface TecDocCatalogGroup {
  assemblyGroupNodeId: number;
  name: string;
  searchNames?: string[];
  parentNodeId?: number | null;
  children: number;
  count: number;
  sortNo?: number;
}

export interface TecDocCatalogGroupPart {
  name: string | null;
  positions: string[];
  articles: TecDocCatalogArticle[];
  oeNumbers: string[];
  articleCount: number;
}

export interface TecDocCatalogArticle {
  brand: string;
  number: string;
  name: string | null;
  description: string | null;
  imageUrl: string | null;
  imageUrls: string[];
  criteria: Array<{ name: string; value: string }>;
  oeNumbers: string[];
  availability: {
    quantity: number;
    is_lower_bound: boolean;
    provider_count: number;
    providers: string[];
  } | null;
}

export interface TecDocCatalogGroupPartsResponse {
  items: TecDocCatalogGroupPart[];
  loaded_articles: number;
  total_articles: number;
  has_more: boolean;
}

export interface OrderLight {
  readiness?: OrderReadiness;
  expected_at_precision?: 'DATE' | 'DATETIME';
  eta_postponed?: boolean;
  eta_previous_expected_at?: string | Date | null;
  eta_current_expected_at?: string | Date | null;
  eta_previous_precision?: 'DATE' | 'DATETIME' | null;
  eta_current_precision?: 'DATE' | 'DATETIME' | null;
  eta_postponement_reason?: string | null;
  eta_postponed_at?: string | Date | null;
  id: number;
  date: Date;
  date_expected: Date;
  description: string;
  is_canceled?: boolean;
  date_canceled?: Date | null;
  cancel_reason?: string | null;
  source: OrderSource;
  client: string;
  client_id: number;
  manager: string;
  car: string;
  client_phone: string;
  vin: string;
  warehouse: string;
  staging_cells?: Array<{ cell_id: number; cell_code: string }>;
  products: ProductInDoc[];
  sum: number;
  status_summary: OrderStatusSummary;
  invoice_count: number;
  invoice_total: number;
  paid_total: number;
  returned_total: number;
  collectible_total: number;
  refunded_total: number;
  refund_due_total: number;
  has_returns: boolean;
  supply_status: OrderSupplyStatus;
  payment_status: OrderPaymentStatus;
  shipment_status: OrderShipmentStatus;
  delivery?: OrderDelivery;
}

export interface UpdateProviderDto {
  id: number;
  description: string;
  fullDescription: string;
  taxNum?: string;
  orgNum?: string;
}

export interface UpdateUploadSettingsDto {
  id: number;
  uploadDescription?: string;
  uploadBrand?: string;
  uploadArticle?: string;
  uploadPrice?: string;
}

export interface ProviderWithDebt {
  id: number;
  description: string;
  debt: number;
}

export interface CreateUserDto {
  readonly name: string;
  readonly phone: string;
  readonly password: string;
  readonly roleId: number[];
  readonly bankId: number[];
  readonly defaultWarehouseId: number;
  readonly defaultOrgId: number;
  readonly catalogueOpenFilter?: boolean;
  readonly catalogueOpenFolder?: boolean;
}
export interface UpdateUserDto {
  readonly id: number;
  readonly name?: string;
  readonly defaultWarehouseId?: number;
  readonly defaultOrgId?: number;
  readonly labelPrinter?: string;
  readonly defaultLabelProfileId?: number | string | null;
  readonly defaultLabelProfileCode?: string | null;
  readonly thermalPrinter?: string;
  readonly catalogueOpenFilter?: boolean;
  readonly catalogueOpenFolder?: boolean;
  readonly therminal?: string;
  readonly fiscal_id?: number | null;
  readonly lightmode?: boolean;
}

export interface AddBankToUserDto {
  readonly bank_id: number;
  readonly user_id: number;
}

export interface RemoveBankFromUserDto {
  readonly bank_id: number;
  readonly user_id: number;
}

export interface UpdateProductCellInWarehouse {
  readonly row_id: number;
  readonly cell: string;
}

export interface NewCatalogProductFolderRef {
  id: number;
  description?: string | null;
}

export interface NewCatalogSearchMatch {
  kind: 'EXACT' | 'MANUAL' | 'TECDOC' | 'EXTERNAL';
  article: string;
  brand?: string | null;
  sourceProductId?: number;
  source?: string;
  matchType?: string;
}

export interface NewCatalogProductListItem {
  id: number;
  article: string;
  articleTrim: string;
  brandId: number;
  brandName: string;
  brandShortName?: string | null;
  brandLogo?: string | null;
  brandRating?: number | null;
  name: string;
  nameUa?: string | null;
  price?: number | null;
  retail?: number | null;
  public: boolean;
  updateRetail: boolean;
  stockTotal: number;
  imageName?: string | null;
  imageUrl?: string | null;
  fallbackImageUrl?: string | null;
  stocks: NewCatalogProductStock[];
  providerAvailability: NewCatalogProviderAvailability;
  folders?: NewCatalogProductFolderRef[];
  searchMatches?: NewCatalogSearchMatch[];
}

export interface NewCatalogProductSearchResponse {
  query: string;
  limit: number;
  offset: number;
  total: number;
  facets: NewCatalogSearchFacets;
  warehouseLegend: NewCatalogWarehouseLegend[];
  items: NewCatalogProductListItem[];
}

export interface NewCatalogProductImage {
  productId: number;
  imageUrl: string;
}

export interface NewCatalogProductImagesResponse {
  items: NewCatalogProductImage[];
}

export interface ProductRepricingStartResult {
  started: boolean;
  skipped?: boolean;
  message: string;
}

export interface NewCatalogSearchFacets {
  brands: NewCatalogBrandFacet[];
  properties: NewCatalogPropertyFacet[];
}

export interface NewCatalogBrandFacet {
  id: number;
  description: string;
  count: number;
}

export interface NewCatalogPropertyFacetValue {
  value: string;
  count: number;
  selected: boolean;
}

export type NewCatalogPropertyFacetMode = 'values' | 'range' | 'contains';

export interface NewCatalogAppliedValuesPropertyFilter {
  mode: 'values';
  property_id: number;
  values: string[];
}

export interface NewCatalogAppliedRangePropertyFilter {
  mode: 'range';
  property_id: number;
  min: number | null;
  max: number | null;
}

export interface NewCatalogAppliedContainsPropertyFilter {
  mode: 'contains';
  property_id: number;
  value: string;
}

export type NewCatalogAppliedPropertyFilter =
  | NewCatalogAppliedValuesPropertyFilter
  | NewCatalogAppliedRangePropertyFilter
  | NewCatalogAppliedContainsPropertyFilter;

export interface NewCatalogPropertyFacet {
  property: Property;
  mode: NewCatalogPropertyFacetMode;
  values?: NewCatalogPropertyFacetValue[];
  min?: number | null;
  max?: number | null;
}

export interface NewCatalogIncomingDelivery {
  buyId: number;
  providerName: string;
  expectedAt: Date | string;
  quantity: number;
}

export type NewCatalogIncomingTransferStatus =
  | 'DRAFT'
  | 'PICKING'
  | 'READY_TO_DISPATCH'
  | 'IN_TRANSIT'
  | 'PARTIALLY_RECEIVED';

export interface NewCatalogIncomingTransfer {
  movingDocId: number;
  sourceWarehouseId: number;
  sourceWarehouseName: string;
  status: NewCatalogIncomingTransferStatus;
  createdAt: Date | string;
  dispatchedAt?: Date | string | null;
  quantity: number;
}

export interface NewCatalogProductStock {
  warehouseId: number;
  warehouseName: string;
  quantity: number;
  customerReservedQuantity?: number;
  transferReservedQuantity?: number;
  freeQuantity?: number;
  incomingQuantity?: number;
  incomingDeliveries?: NewCatalogIncomingDelivery[];
  incomingTransferQuantity?: number;
  incomingTransfers?: NewCatalogIncomingTransfer[];
  cell?: string | null;
  minimumStock: number;
}

export interface NewCatalogWarehouseLegend {
  warehouseId: number;
  warehouseName: string;
  cityId?: number | null;
  cityName?: string | null;
  isPrimaryForManager: boolean;
}

export interface NewCatalogProviderAvailability {
  inCityQty: number;
  outOfCityQty: number;
  inCityDetails: NewCatalogProviderAvailabilityDetail[];
  outOfCityDetails: NewCatalogProviderAvailabilityDetail[];
}

export interface NewCatalogProviderAvailabilityDetail {
  providerId: number;
  providerName: string;
  quantity: number;
  price?: number | null;
}

export type NewCatalogPartInfoSource = 'tecdoc' | 'local';

export interface NewCatalogPartInfoImage {
  url?: string | null;
  name?: string | null;
  source: NewCatalogPartInfoSource;
}

export interface NewCatalogPartInfoCriterion {
  name: string;
  value: string;
  unit?: string | null;
  source: NewCatalogPartInfoSource;
}

export interface NewCatalogPartInfoManufacturer {
  logoUrl?: string | null;
  country?: string | null;
  countryCode?: string | null;
}

export interface NewCatalogPartInfoAnalogueStock {
  warehouseId: number;
  warehouseName: string;
  quantity: number;
  isPrimary: boolean;
}

export interface NewCatalogPartInfoAnalogue {
  productId: number;
  brandName: string | null;
  article: string | null;
  name: string | null;
  price?: number | null;
  image?: NewCatalogPartInfoImage | null;
  imageName?: string | null;
  imageUrl?: string | null;
  fallbackImageUrl?: string | null;
  stockTotal: number;
  stocks: NewCatalogPartInfoAnalogueStock[];
  providerTotal: number;
  providerInCityQty: number;
  providerOutOfCityQty: number;
  providerInCityDetails: NewCatalogProviderAvailabilityDetail[];
  providerOutOfCityDetails: NewCatalogProviderAvailabilityDetail[];
}

export interface NewCatalogPartInfo {
  productId: number;
  brandName: string | null;
  article: string | null;
  name: string | null;
  nameUa?: string | null;
  genericArticleName?: string | null;
  tecdocMatched: boolean;
  manufacturer?: NewCatalogPartInfoManufacturer | null;
  images: NewCatalogPartInfoImage[];
  criteria: NewCatalogPartInfoCriterion[];
  manualAnalogues: NewCatalogPartInfoAnalogue[];
}

export interface NewCatalogPartApplicabilityItem {
  manufacturer: string | null;
  model: string | null;
  type: string | null;
  yearsLabel: string | null;
  engineCodes: string[];
  powerLabel?: string | null;
  fuelType?: string | null;
}

export interface NewCatalogPartApplicability {
  source: NewCatalogPartInfoSource | 'none';
  total: number;
  items: NewCatalogPartApplicabilityItem[];
}

export type WarehouseSupplyRecommendationAction = 'BUY' | 'MOVE' | 'WATCH';
export type WarehouseSupplyRecommendationKind = 'DEFICIT' | 'REPLENISHMENT';
export type WarehouseSupplyProductScope = 'ALL' | 'FILTERS';
export type WarehouseSupplySupplierRanking = 'DEFAULT' | 'PRICE_BRAND_RATING';
export type WarehouseSupplyFilterType = 'AIR' | 'OIL' | 'FUEL' | 'CABIN' | 'OTHER';

export type WarehouseSupplyGroupConfidence = 'MANUAL' | 'SUPPLIER' | 'OE' | 'PRODUCT_ONLY';

export interface WarehouseSupplyRecommendationSearchDto {
  warehouse_ids?: number[];
  query?: string;
  action?: WarehouseSupplyRecommendationAction;
  actions?: WarehouseSupplyRecommendationAction[];
  kind?: WarehouseSupplyRecommendationKind;
  limit?: number;
  offset?: number;
  sales_window_days?: number;
  include_replenishment?: boolean;
  product_scope?: WarehouseSupplyProductScope;
  supplier_ranking?: WarehouseSupplySupplierRanking;
}

export interface WarehouseSupplyProductRef {
  id: number;
  description: string;
  article: string;
  articleTrim: string;
  brandId?: number | null;
  brandName?: string | null;
  price?: number | null;
  retail?: number | null;
  filterType?: WarehouseSupplyFilterType | null;
}

export interface WarehouseSupplyWarehouseRef {
  id: number;
  description: string;
  cityId?: number | null;
  cityName?: string | null;
}

export interface WarehouseSupplyOrderRef {
  id: number;
  dateCreated?: Date | string | null;
  dateExpected?: Date | string | null;
  client?: string | null;
  manager?: string | null;
  productId: number;
  orderedQuan: number;
  shippedQuan: number;
  waitingSupplyQuan: number;
  providerId?: number | null;
  providerName?: string | null;
}

export interface WarehouseSupplyGroup {
  key: string;
  confidence: WarehouseSupplyGroupConfidence;
  anchorProduct: WarehouseSupplyProductRef;
  products: WarehouseSupplyProductRef[];
}

export interface WarehouseSupplyDemand {
  deficitQty: number;
  blockingOrdersCount: number;
  sales30Qty: number;
  sales90Qty: number;
  sales365Qty: number;
  seasonalQty: number;
  sales30Count: number;
  sales90Count: number;
  sales365Count: number;
  seasonalCount: number;
  avgDailySales: number;
  reorderPoint: number;
  targetStock: number;
  replenishmentGap: number;
  orderRefs: WarehouseSupplyOrderRef[];
}

export interface WarehouseSupplyStockWarehouse {
  warehouse: WarehouseSupplyWarehouseRef;
  qty: number;
  placedQty: number;
  bufferQty: number;
  unassignedOutQty: number;
}

export interface WarehouseSupplyStock {
  targetWarehouseQty: number;
  targetPlacedQty: number;
  targetBufferQty: number;
  targetUnassignedOutQty: number;
  incomingBuyQty?: number;
  totalQty: number;
  warehouses: WarehouseSupplyStockWarehouse[];
}

export interface WarehouseSupplyMoveOption {
  warehouse: WarehouseSupplyWarehouseRef;
  qty: number;
  exactProductMatch: boolean;
  productIds: number[];
}

export interface WarehouseSupplySupplierOption {
  productId: number;
  providerId?: number | null;
  providerName?: string | null;
  providerWarehouseId?: number | null;
  providerWarehouseDescription?: string | null;
  contractId?: number | null;
  providerCode?: string | null;
  brand: string;
  article: string;
  name?: string | null;
  price?: number | null;
  quantity: number;
  quantityQualifier: SupplierPriceQuantityQualifier;
  rawQuantity?: string | null;
  cityId?: number | null;
  cityName?: string | null;
  inTargetCity: boolean;
  brandRating?: number | null;
}

export interface WarehouseSupplyRecommendation {
  action: WarehouseSupplyRecommendationAction;
  qty: number;
  rawQty?: number;
  saleBatchQty?: number;
  targetWarehouse: WarehouseSupplyWarehouseRef;
  sourceWarehouse?: WarehouseSupplyWarehouseRef | null;
  reasons: string[];
}

export interface WarehouseSupplyRecommendationRow {
  id: string;
  priority: number;
  kind: WarehouseSupplyRecommendationKind;
  group: WarehouseSupplyGroup;
  warehouse: WarehouseSupplyWarehouseRef;
  demand: WarehouseSupplyDemand;
  stock: WarehouseSupplyStock;
  recommendation: WarehouseSupplyRecommendation;
  supplierOptions: WarehouseSupplySupplierOption[];
  recommendedSupplierOption?: WarehouseSupplySupplierOption | null;
  moveOptions: WarehouseSupplyMoveOption[];
}

export interface WarehouseSupplyRecommendationsSummary {
  total: number;
  deficitRows: number;
  replenishmentRows: number;
  buyRows: number;
  moveRows: number;
  watchRows: number;
}

export interface WarehouseSupplyRecommendationsResponse {
  data: WarehouseSupplyRecommendationRow[];
  length: number;
  summary: WarehouseSupplyRecommendationsSummary;
  warehouseLegend: WarehouseSupplyWarehouseRef[];
}

export type WarehouseSupplyAiConfidence = 'HIGH' | 'MEDIUM' | 'LOW';

export interface WarehouseSupplyAiSuggestion {
  recommendationId: string;
  product: {
    id: number;
    brand: string;
    article: string;
    name: string;
  };
  warehouse: {
    id: number;
    name: string;
  };
  recommendedQty: number;
  confidence: WarehouseSupplyAiConfidence;
  reason: string;
  risks: string[];
  supplier: {
    providerId: number | null;
    name: string;
    productId: number;
    price: number | null;
    availableQty: number;
  } | null;
}

export interface WarehouseSupplyAiSuggestionsResponse {
  summary: string;
  suggestions: WarehouseSupplyAiSuggestion[];
  evidence: {
    analyzedCandidates: number;
    totalPurchaseCandidates: number;
    selectionDocuments: number;
    catalogSources: Array<'LAXIMO' | 'TECDOC'>;
  };
  usage: {
    cached: boolean;
    promptTokens: number;
    completionTokens: number;
    model: string;
  };
  analyzedAt: Date | string;
}

export interface NewCatalogSupplierMissingStock {
  providerWarehouseId: number;
  warehouseName: string;
  quantity: number;
  quantityQualifier: SupplierPriceQuantityQualifier;
  rawQuantity?: string | null;
}

export interface NewCatalogSupplierMissingItem {
  id: number;
  contractId: number;
  contractNumber?: string | null;
  providerId?: number | null;
  providerName?: string | null;
  brand: string;
  article: string;
  externalProductId?: string | null;
  name?: string | null;
  price?: number | null;
  barcode?: string | null;
  salesOrderMultiple?: number | null;
  stockTotal: number;
  updatedAt: Date | string;
  stocks: NewCatalogSupplierMissingStock[];
}

export interface NewCatalogSupplierMissingResponse {
  query: string;
  limit: number;
  offset: number;
  total: number;
  facets: NewCatalogSupplierMissingFacets;
  items: NewCatalogSupplierMissingItem[];
}

export interface NewCatalogSupplierMissingProviderFacet {
  id: number;
  description: string;
  count: number;
}

export interface NewCatalogSupplierMissingFacets {
  providers: NewCatalogSupplierMissingProviderFacet[];
}

export interface NewCatalogSupplierMissingCreatePayload {
  item_id?: number;
  description: string;
  article: string;
  brand?: string;
  brand_id?: number;
  barcode?: string | null;
  price?: number | null;
}

export interface NewCatalogCreateProductFromSupplierInfoPayload {
  contract_id: number;
  brand: string;
  article: string;
  description?: string;
  description_long?: string;
  barcode?: string | null;
  price?: number | null;
  retail?: number | null;
  allow_stale?: boolean;
}

export interface NewCatalogCreateProductFromSupplierInfoResponse {
  status: 'created' | 'matched_existing';
  product: Product;
  relationCounts: {
    analogueCount: number;
    oeCount: number;
  };
}

export interface NewCatalogSupplierMissingActionResult {
  itemId: number;
  productId: number;
  status: string;
}

export interface NewCatalogSupplierMissingBulkCreateResult {
  created: NewCatalogSupplierMissingActionResult[];
  linked: NewCatalogSupplierMissingActionResult[];
  failed: Array<{
    itemId: number;
    message: string;
  }>;
}

export interface CatalogIdentityBrandSummary {
  id: number;
  description: string;
  shortDescription?: string | null;
}

export interface CatalogIdentityProductDuplicateGroup {
  articleTrim: string;
  products: {
    id: number;
    article: string;
    description: string;
    brand: CatalogIdentityBrandSummary;
  }[];
  reasons: string[];
}

export interface CatalogIdentityBrandIssue {
  id: number;
  source: string;
  rawBrand: string;
  normalizedBrand: string;
  article?: string | null;
  articleTrim?: string | null;
  occurrences: number;
  createdAt: string;
  lastSeenAt: string;
  suggestedBrand?: CatalogIdentityBrandSummary | null;
  candidateBrands: CatalogIdentityBrandSummary[];
  context: Record<string, unknown>;
}

export interface CatalogIdentityBrandConflictBrand extends CatalogIdentityBrandSummary {
  productCount: number;
}

export interface CatalogIdentityBrandConflict {
  normalizedKey: string;
  brands: CatalogIdentityBrandConflictBrand[];
}

export type CurrencyTrendDirection = 'up' | 'down' | 'flat';

export interface CurrencyTrendRate {
  currency: 'USD' | 'EUR';
  buy: number;
  sale: number;
  previousBuy: number | null;
  previousSale: number | null;
  buyDelta: number;
  saleDelta: number;
  trend: CurrencyTrendDirection;
}

export interface CurrencyTrendResponse {
  date_created: string | Date | null;
  previous_date_created: string | Date | null;
  rates: CurrencyTrendRate[];
}

export interface B2cPresenceResponse {
  online: number;
  ttlSeconds: number;
  sampledAt: string | Date;
}

export type OilBenchmark = 'BRENT';

export interface OilHistoryPoint {
  date: string;
  price: number;
}

export interface OilHistoryLatest {
  date: string;
  price: number;
  monthPrice: number | null;
  monthDelta: number;
  monthDeltaPercent: number;
  trend: CurrencyTrendDirection;
}

export interface OilHistoryResponse {
  benchmark: OilBenchmark;
  unit: 'USD_PER_BARREL';
  source: string;
  latest: OilHistoryLatest;
  points: OilHistoryPoint[];
}

export interface LaximoVehicleAttribute {
  key: string;
  name?: string;
  value?: string;
}

export interface LaximoVehicle {
  catalog: string;
  brand: string;
  name: string;
  vehicleId: string;
  ssd: string;
  attributes: LaximoVehicleAttribute[];
}

export interface LaximoVehiclesResponse {
  vin: string;
  vehicles: LaximoVehicle[];
}

export interface LaximoQuickGroup {
  quickGroupId: number;
  name: string;
  link: boolean;
  children: LaximoQuickGroup[];
}

export interface LaximoQuickGroupsResponse {
  groups: LaximoQuickGroup[];
}

export interface LaximoCategory {
  categoryId: string;
  name: string;
  code?: string;
  ssd: string;
  children: LaximoCategory[];
}

export interface LaximoCategoriesResponse {
  categories: LaximoCategory[];
}

export interface LaximoUnit {
  unitId: string;
  code: string;
  name: string;
  ssd: string;
  imageUrl?: string;
}

export interface LaximoUnitsResponse {
  units: LaximoUnit[];
}

export interface LaximoQuickDetailPart {
  codeOnImage?: string;
  oem?: string;
  name: string;
  amount?: string;
  note?: string;
  attributes: Array<{
    key: string;
    label: string;
    value: string;
  }>;
  match: boolean;
}

export interface LaximoQuickDetailUnit {
  unitId: string;
  code: string;
  name: string;
  ssd: string;
  imageUrl?: string;
  note?: string;
  details: LaximoQuickDetailPart[];
}

export interface LaximoQuickDetailCategory {
  categoryId: string;
  name: string;
  units: LaximoQuickDetailUnit[];
}

export interface LaximoQuickDetailsResponse {
  categories: LaximoQuickDetailCategory[];
}

export interface LaximoUnitDetailsResponse {
  details: LaximoQuickDetailPart[];
}

export interface LaximoImageMapZone {
  code: string;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export interface LaximoUnitImageMapResponse {
  zones: LaximoImageMapZone[];
}

export type SearchHistoryKind = 'vin' | 'phone' | 'product' | 'text';

export interface SearchHistoryEntry {
  id: number;
  query: string;
  kind?: SearchHistoryKind | null;
  label?: string | null;
  dateUpdated: string | Date;
  userName?: string | null;
}

export interface SearchHistoryListResponse {
  items: SearchHistoryEntry[];
}

export interface ProductMergeCard {
  id: number; article: string; description: string; brand: string | null;
  brandId: number | null; stock: number; price: number; retail: number;
  articles: string[]; barcodes: string[];
}
export interface ProductMergePreview {
  main: ProductMergeCard; sources: ProductMergeCard[];
  warnings: string[]; blockers: string[]; impacts: { label: string; count: number }[];
  resultingStock: number; resultingPrice: number; resultingRetail: number;
  resultingDescription: string; preview_token: string;
}
